(function(){
  'use strict';

  // Centralized backend URL — set via theme.liquid bridge (window.KZ_BACKENDS).
  var API = (window.KZ_BACKENDS && window.KZ_BACKENDS.kzDesk) || 'https://kzdesk.com';
  var attachmentHelper=window.KZReturnsAttachments;
  var returnsAssets=window.__kzReturnsAssets||{};
  var attachmentFlowSequence=0;
  var attachmentFlow=createAttachmentFlow();
  var SESSION_KEY='kz_returns_portal_session_v3';
  var SESSION_TTL_MS=15*60*1000;
  var MAX_STORED_HISTORY=40;
  // Desk rejects raw JSON above 10M chars and image data at 7M chars.
  // Keep 500k-char margins so small contract changes do not cross either boundary.
  var MAX_CHAT_BODY_LENGTH=9500000;
  var MAX_CHAT_IMAGE_DATA_LENGTH=6500000;
  var CHAT_BODY_TOO_LARGE_MESSAGE='As fotos juntas ficaram grandes demais para enviar. Remova uma foto e tente novamente.';
  var CHAT_IMAGE_TOO_LARGE_MESSAGE='Uma das fotos ficou grande demais para enviar. Remova essa foto ou envie uma imagem menor.';

  function createAttachmentFlow(){
    return{id:++attachmentFlowSequence,queue:Promise.resolve(),pending:0,errorVersion:0};
  }
  function resetAttachmentFlow(){attachmentFlow=createAttachmentFlow()}
  function isCurrentAttachmentFlow(flow){return flow===attachmentFlow}

  function createTurnId(){
    try{
      if(window.crypto&&typeof window.crypto.randomUUID==='function')return window.crypto.randomUUID();
      if(window.crypto&&typeof window.crypto.getRandomValues==='function'){
        var bytes=new Uint8Array(16);window.crypto.getRandomValues(bytes);
        return Array.prototype.map.call(bytes,function(b){return b.toString(16).padStart(2,'0')}).join('');
      }
    }catch(e){}
    return 'turn-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,12);
  }

  function esc(s){if(!s)return '';var d=document.createElement('div');d.textContent=String(s);return d.innerHTML}
  function toTitleCase(s){if(!s)return '';return String(s).trim().split(/\s+/).map(function(w){return w.charAt(0).toUpperCase()+w.slice(1).toLowerCase()}).join(' ')}
  function renderTextWithLinks(parent,text){
    var urlRe=/(https?:\/\/[^\s),]+)/g;
    var boldRe=/\*\*([^*]+)\*\*/g;
    (text||'').split('\n').forEach(function(line,i){
      if(i>0)parent.appendChild(document.createElement('br'));
      // First split by URLs
      var parts=line.split(urlRe);
      for(var j=0;j<parts.length;j++){
        if(urlRe.test(parts[j])){
          urlRe.lastIndex=0;
          var a=document.createElement('a');a.href=parts[j];a.target='_blank';a.rel='noopener noreferrer';
          a.style.cssText='color:#17d4e6;text-decoration:underline';a.textContent=parts[j];
          parent.appendChild(a);
        } else if(parts[j]){
          // Process bold **text** within non-URL segments
          var seg=parts[j];var boldParts=seg.split(boldRe);
          for(var k=0;k<boldParts.length;k++){
            if(k%2===1){var b=document.createElement('strong');b.textContent=boldParts[k];parent.appendChild(b)}
            else if(boldParts[k]){parent.appendChild(document.createTextNode(boldParts[k]))}
          }
        }
      }
    });
  }
  function $(id){return document.getElementById(id)}
  function pageScrollY(){return window.scrollY||document.documentElement.scrollTop||0}
  function beginChatTransition(){if(state){state._chatTransitionScrollY=pageScrollY();state._pageScrollY=state._chatTransitionScrollY}}
  function rememberPageScrollForRender(){
    if(!state)return;
    state._pageScrollY=typeof state._chatTransitionScrollY==='number'?state._chatTransitionScrollY:pageScrollY();
  }
  function focusWithoutPageScroll(node){
    if(!node)return;
    var y=pageScrollY();
    try{node.focus({preventScroll:true})}
    catch(e){node.focus();window.scrollTo(0,y)}
  }
  function el(tag,attrs,children){
    var e=document.createElement(tag);
    if(attrs)Object.keys(attrs).forEach(function(k){
      if(k==='className')e.className=attrs[k];
      else if(k.indexOf('on')===0)e[k]=attrs[k];
      else e.setAttribute(k,attrs[k]);
    });
    if(typeof children==='string')e.textContent=children;
    else if(Array.isArray(children))children.forEach(function(c){if(c)e.appendChild(c)});
    return e;
  }
  function safeSessionStorage(){
    try{
      var s=window.sessionStorage;
      var k='__kz_ret_test';
      s.setItem(k,'1');s.removeItem(k);
      return s;
    }catch(e){return null}
  }
  function parseAuthPayload(auth){
    try{return auth&&auth.payload?JSON.parse(auth.payload):null}catch(e){return null}
  }
  function cleanText(s,max){
    if(typeof s!=='string')return '';
    return s.slice(0,max||4000);
  }
  function importAttachmentModule(url){
    var loader=window.__kzImportHeicDecoder;
    if(typeof loader!=='function')return Promise.reject(new Error('HEIC module loader unavailable'));
    return loader(url);
  }
  var convertHeic=attachmentHelper&&typeof attachmentHelper.createHeicConverter==='function'
    ?attachmentHelper.createHeicConverter(importAttachmentModule,returnsAssets.heicDecoderUrl)
    :function(){return Promise.reject(new Error('Attachment helper unavailable'))};
  function rasterizeImage(blob,options){
    return new Promise(function(resolve,reject){
      var objectUrl;
      var revoked=false;
      function revoke(){
        if(revoked||!objectUrl)return;
        revoked=true;
        URL.revokeObjectURL(objectUrl);
      }
      try{objectUrl=URL.createObjectURL(blob)}catch(error){reject(error);return}
      var image;
      try{
        image=new Image();
        image.onload=function(){
          try{
            var width=image.width;
            var height=image.height;
            if(!width||!height)throw new Error('Invalid image dimensions');
            var maxDimension=options.maxDimension;
            if(width>maxDimension||height>maxDimension){
              if(width>height){height=Math.round(height*(maxDimension/width));width=maxDimension}
              else{width=Math.round(width*(maxDimension/height));height=maxDimension}
            }
            var canvas=document.createElement('canvas');
            canvas.width=width;canvas.height=height;
            var context=canvas.getContext('2d');
            if(!context)throw new Error('Canvas context unavailable');
            context.drawImage(image,0,0,width,height);
            var dataUrl=canvas.toDataURL('image/jpeg',options.quality);
            var separator=dataUrl.indexOf(',');
            var data=separator>=0?dataUrl.slice(separator+1):'';
            if(!data)throw new Error('Canvas output unavailable');
            resolve({data:data,type:'image/jpeg'});
          }catch(error){reject(error)}finally{revoke()}
        };
        image.onerror=function(){
          try{reject(new Error('Browser could not decode image'))}finally{revoke()}
        };
        image.src=objectUrl;
      }catch(error){
        try{reject(error)}finally{revoke()}
      }
    });
  }
  var attachmentAdapters={convertHeic:convertHeic,rasterize:rasterizeImage};
  function safeImageUrl(url){
    url=String(url||'').trim();
    if(url.indexOf('//')===0)return 'https:'+url;
    if(/^https:\/\//i.test(url))return url;
    return '';
  }
  function formatPriceBRL(value){
    var raw=String(value===undefined||value===null?'':value).trim();
    var amount=Number(raw.replace(/\s/g,'').replace(/^R\$\s?/i,'').replace(',','.'));
    if(!isFinite(amount))return raw?('R$ '+raw):'';
    try{return new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(amount)}
    catch(e){return 'R$ '+amount.toFixed(2).replace('.',',')}
  }
  function cleanCatalogSelection(selection){
    if(!selection||typeof selection!=='object')return null;
    var handle=cleanText(String(selection.handle||''),250).trim();
    var variantId=cleanText(String(selection.variant_id||''),250).trim();
    if(!handle||!variantId)return null;
    var out={handle:handle,variant_id:variantId};
    var productName=cleanText(String(selection.product_name||selection.title||''),500).trim();
    var variantTitle=cleanText(String(selection.variant_title||''),300).trim();
    var price=cleanText(String(selection.price===undefined||selection.price===null?'':selection.price),80).trim();
    var image=safeImageUrl(selection.image||selection.variant_image||selection.product_image||'');
    if(productName)out.product_name=productName;
    if(variantTitle&&variantTitle!=='Default Title')out.variant_title=variantTitle;
    if(price)out.price=price;
    if(image)out.image=image;
    return out;
  }
  function productNameKey(name){
    return String(name||'').trim().toLowerCase();
  }
  function cleanOrderItemsForStorage(items){
    if(!Array.isArray(items))return [];
    return items.map(function(item){
      if(!item||typeof item!=='object')return null;
      var name=cleanText(String(item.product_name||item.name||''),500).trim();
      if(!name)return null;
      var out={product_name:name};
      var lineItemId=item.line_item_id===undefined||item.line_item_id===null?'':String(item.line_item_id).trim();
      if(lineItemId)out.line_item_id=lineItemId;
      var qty=Number(item.quantity);
      if(isFinite(qty)&&qty>0)out.quantity=qty;
      var image=safeImageUrl(item.image||item.image_url||item.product_image||'');
      if(image)out.image=image;
      return out;
    }).filter(Boolean).slice(0,50);
  }
  function cleanSelectedLineItemIds(ids,items){
    if(!Array.isArray(ids)||!Array.isArray(items))return [];
    var allowed={};
    items.forEach(function(item){
      var id=item&&item.line_item_id!==undefined&&item.line_item_id!==null?String(item.line_item_id).trim():'';
      if(id)allowed[id]=true;
    });
    var seen={};
    return ids.map(function(id){return String(id||'').trim()}).filter(function(id){
      if(!id||!allowed[id]||seen[id])return false;
      seen[id]=true;return true;
    }).slice(0,50);
  }
  function cleanProductCards(cards){
    if(!Array.isArray(cards))return [];
    return cards.map(function(card){
      if(!card||typeof card!=='object')return null;
      var name=cleanText(String(card.name||card.product_name||''),500).trim();
      if(!name)return null;
      var out={name:name};
      var qty=Number(card.quantity);
      if(isFinite(qty)&&qty>1)out.quantity=qty;
      var image=safeImageUrl(card.image||card.image_url||'');
      if(image)out.image=image;
      return out;
    }).filter(Boolean).slice(0,8);
  }
  function productCardFromItem(item){
    if(!item||typeof item!=='object')return null;
    var name=cleanText(String(item.product_name||item.name||''),500).trim();
    if(!name)return null;
    var card={name:name};
    var qty=Number(item.quantity);
    if(isFinite(qty)&&qty>1)card.quantity=qty;
    var image=safeImageUrl(item.image||item.image_url||item.product_image||'');
    if(image)card.image=image;
    return card;
  }
  function productCardsFromItems(items){
    if(!Array.isArray(items))return [];
    return cleanProductCards(items.map(productCardFromItem).filter(Boolean));
  }
  function mergeOrderItemsWithLocalImages(items,localItems){
    var remote=cleanOrderItemsForStorage(items);
    var local=cleanOrderItemsForStorage(localItems);
    if(remote.length===0)return local;
    if(local.length===0)return remote;
    var byName={};
    local.forEach(function(item){byName[productNameKey(item.product_name)]=item});
    return remote.map(function(item,idx){
      var localMatch=byName[productNameKey(item.product_name)]||local[idx]||null;
      if(localMatch&&localMatch.image&&!item.image)item.image=localMatch.image;
      return item;
    });
  }
  function cleanHistoryForStorage(history){
    if(!Array.isArray(history))return [];
    return history.slice(-MAX_STORED_HISTORY).map(function(msg){
      if(!msg||typeof msg!=='object')return null;
      var role=msg.role;
      if(['user','assistant','system','notification'].indexOf(role)===-1)return null;
      var out={role:role,content:cleanText(msg.content||'',5000)};
      if(msg.ts)out.ts=msg.ts;
      if(msg.old)out.old=true;
      if(msg.status)out.status=cleanText(msg.status,80);
      if(Array.isArray(msg.images)){
        var imgs=msg.images.filter(function(src){return /^https:\/\//i.test(String(src))}).slice(0,8);
        if(imgs.length)out.images=imgs;
      }
      if(Array.isArray(msg.product_cards)){
        var cards=cleanProductCards(msg.product_cards);
        if(cards.length)out.product_cards=cards;
      }
      var selection=cleanCatalogSelection(msg.product_selection);
      if(selection)out.product_selection=selection;
      if(selection&&msg.product_selection_inactive===true)out.product_selection_inactive=true;
      if(msg.product_prompt)out.product_prompt=cleanText(msg.product_prompt,500);
      return out;
    }).filter(Boolean);
  }
  function clearReturnSession(){
    var storage=safeSessionStorage();
    if(storage)try{storage.removeItem(SESSION_KEY);storage.removeItem('kz_returns_portal_session_v2')}catch(e){}
  }
  function storedSessionIsCompatible(saved,tokenData){
    if(!saved||saved.v!==3||!tokenData)return false;
    if(!saved.expiresAt||Date.now()>=saved.expiresAt)return false;
    if(!tokenData.exp||Date.now()>=tokenData.exp)return false;
    if(!tokenData.sessionId||typeof tokenData.sessionId!=='string')return false;
    if(!tokenData.email||!tokenData.orderNumber)return false;
    if(String(saved.selectedOrder||'')!==String(tokenData.orderNumber||''))return false;
    if(String(saved.loginEmail||'').toLowerCase()!==String(tokenData.email||'').toLowerCase())return false;
    if(kzCustomer&&kzCustomer.email&&String(kzCustomer.email).toLowerCase()!==String(tokenData.email).toLowerCase())return false;
    return true;
  }
  function restoreReturnSession(){
    var storage=safeSessionStorage();
    if(!storage)return false;
    var saved=null;
    try{saved=JSON.parse(storage.getItem(SESSION_KEY)||'null')}catch(e){clearReturnSession();return false}
    var tokenData=parseAuthPayload(saved&&saved.auth);
    if(!storedSessionIsCompatible(saved,tokenData)){clearReturnSession();return false}

    var allowedSteps={tracking:true,select_product:true,chat:true};
    state.auth=saved.auth;
    state.loginEmail=saved.loginEmail;
    state.step=allowedSteps[saved.step]?saved.step:'chat';
    state.history=cleanHistoryForStorage(saved.history);
    state.accumulatedImageUrls=Array.isArray(saved.accumulatedImageUrls)?saved.accumulatedImageUrls.filter(function(u){return /^https:\/\//i.test(String(u))}).slice(0,20):[];
    state.returnContext=typeof saved.returnContext==='string'?saved.returnContext:null;
    state.addressData=saved.addressData&&typeof saved.addressData==='object'?saved.addressData:null;
    state.addressMode=saved.addressMode||null;
    state.showAddress=saved.showAddress===true;
    state.returnCreated=saved.returnCreated===true;
    state.returnCompleted=saved.returnCompleted===true;
    state.selectedOrder=String(saved.selectedOrder||tokenData.orderNumber);
    state.orderItems=cleanOrderItemsForStorage(saved.orderItems);
    state.selectedProduct=typeof saved.selectedProduct==='string'?saved.selectedProduct:null;
    state.selectedLineItemIds=cleanSelectedLineItemIds(saved.selectedLineItemIds,state.orderItems);
    state.existingReturns=Array.isArray(saved.existingReturns)?saved.existingReturns:[];
    state.historyLoaded=saved.historyLoaded===true;
    state.catalogSelectedProduct=cleanCatalogSelection(saved.catalogSelectedProduct);
    state.catalogReopenAvailable=saved.catalogReopenAvailable===true&&
      state.step==='chat'&&
      state.selectedLineItemIds.length===1&&
      !state.catalogSelectedProduct&&
      !state.returnCreated&&
      !state.returnCompleted;
    state._draftText=typeof saved.draftText==='string'?saved.draftText:'';
    state.sessionRestored=true;
    return true;
  }
  function saveReturnSession(){
    if(!state||!state.auth||!state.auth.token||!state.auth.payload||!state.selectedOrder)return;
    var tokenData=parseAuthPayload(state.auth);
    if(!tokenData||!tokenData.exp||Date.now()>=tokenData.exp){clearReturnSession();return}
    var storage=safeSessionStorage();
    if(!storage)return;
    var draft=state._draftText||'';
    var draftEl=$('kz-chat-in');
    if(draftEl)draft=draftEl.value||'';
    var expiresAt=Math.min(Number(tokenData.exp),Date.now()+SESSION_TTL_MS);
    var payload={
      v:3,
      savedAt:Date.now(),
      expiresAt:expiresAt,
      loginEmail:state.loginEmail,
      auth:{token:state.auth.token,payload:state.auth.payload},
      step:state.step,
      selectedOrder:state.selectedOrder,
      orderItems:cleanOrderItemsForStorage(state.orderItems),
      selectedProduct:state.selectedProduct||null,
      selectedLineItemIds:cleanSelectedLineItemIds(state.selectedLineItemIds,state.orderItems),
      history:cleanHistoryForStorage(state.history),
      historyLoaded:state.historyLoaded===true,
      returnContext:state.returnContext||null,
      accumulatedImageUrls:Array.isArray(state.accumulatedImageUrls)?state.accumulatedImageUrls.filter(function(u){return /^https:\/\//i.test(String(u))}).slice(0,20):[],
      returnCreated:state.returnCreated===true,
      returnCompleted:state.returnCompleted===true,
      existingReturns:Array.isArray(state.existingReturns)?state.existingReturns.slice(0,10):[],
      addressData:state.addressData||null,
      addressMode:state.addressMode||null,
      showAddress:state.showAddress===true,
      catalogSelectedProduct:cleanCatalogSelection(state.catalogSelectedProduct),
      catalogReopenAvailable:state.catalogReopenAvailable===true&&
        state.step==='chat'&&
        state.selectedLineItemIds.length===1&&
        !state.catalogSelectedProduct&&
        !state.returnCreated&&
        !state.returnCompleted,
      draftText:cleanText(draft,2000)
    };
    try{storage.setItem(SESSION_KEY,JSON.stringify(payload))}catch(e){}
  }
  function resetSessionFlow(){
    if(state&&state.chatRequestInFlight)return;
    resetAttachmentFlow();
    if(state.catalogTimer)clearTimeout(state.catalogTimer);
    clearReturnSession();
    state.auth=null;
    state.history=[];
    state.sending=false;
    state.chatRequestInFlight=false;
    state.error='';
    state.images=[];
    state.accumulatedImageUrls=[];
    state.returnContext=null;
    state.addressData=null;
    state.addressMode=null;
    state.showAddress=false;
    state.returnCreated=false;
    state.returnCompleted=false;
    state.selectedProduct=null;
    state.selectedLineItemIds=[];
    state.selectedOrder=null;
    state.orderItems=[];
    state.existingReturns=[];
    state._chatSnapshot=null;
    state._draftText='';
    state.catalogSelectedProduct=null;
    state.catalogReopenAvailable=false;
    state.showCatalog=false;
    state.catalogResults=[];
    state.catalogError='';
    state.catalogRequestId++;
    state.sessionRestored=false;
    if(kzCustomer&&Array.isArray(kzCustomer.orders)&&kzCustomer.orders.length>0){
      state.loginEmail=kzCustomer.email;
      state.eligibleOrders=kzCustomer.orders;
      state.step='orders';
      state.orderEligibility=null;
      loadEligibility();
    }else{
      state.loginEmail='';
      state.eligibleOrders=null;
      state.step='login';
      render();
    }
  }
  function handleAuthSessionError(message){
    if(!/(expirad|token inválido|sessão)/i.test(message||''))return false;
    resetAttachmentFlow();
    if(state.catalogTimer)clearTimeout(state.catalogTimer);
    clearReturnSession();
    state.auth=null;
    state.history=[];
    state.chatRequestInFlight=false;
    state.images=[];
    state.accumulatedImageUrls=[];
    state.returnContext=null;
    state.addressData=null;
    state.showAddress=false;
    state.returnCreated=false;
    state.returnCompleted=false;
    state.selectedProduct=null;
    state.selectedLineItemIds=[];
    state.selectedOrder=null;
    state.orderItems=[];
    state.existingReturns=[];
    state.catalogSelectedProduct=null;
    state.catalogReopenAvailable=false;
    state.showCatalog=false;
    state.catalogResults=[];
    state.catalogError='';
    state.catalogRequestId++;
    state.sessionRestored=false;
    state.error='Por segurança, confirme novamente para continuar.';
    if(kzCustomer&&Array.isArray(kzCustomer.orders)&&kzCustomer.orders.length>0){
      state.loginEmail=kzCustomer.email;
      state.eligibleOrders=kzCustomer.orders;
      state.step='orders';
    }else{
      state.step='login';
    }
    render();
    return true;
  }

  var app=$('kz-ret-app');
  if(!app)return;
  // Prefer the returns-portal-specific global (carries orders); the shared
  // window.__kzCustomer is set by the global webchat widget too and has no orders.
  var kzCustomer=window.__kzReturnsCustomer||window.__kzCustomer||null;

  var state={
    step:'login',
    auth:null,
    history:[],
    sending:false,
    chatRequestInFlight:false,
    activityLabel:'',
    error:'',
    images:[],
    accumulatedImageUrls:[],
    returnContext:null,
    addressData:null,
    showAddress:false,
    returnCreated:false,
    selectedProduct:null,
    selectedLineItemIds:[],
    orderItems:[],
    showCatalog:false,
    catalogReopenAvailable:false,
    catalogSearch:'',
    catalogResults:[],
    catalogSearching:false,
    catalogError:'',
    catalogRequestId:0,
    catalogExpanded:null,
    catalogTimer:null,
    orderEligibility:null,
    eligibilityLoading:false,
    sessionRestored:false,
  };

  var restoredSession=restoreReturnSession();

  // Logged-in Shopify customer: their orders come from the authenticated storefront
  // session (rendered by Liquid), so they skip the email+order form and land straight
  // on their order list — same frictionless access they had before. Picking an order
  // still goes through the secure email+order lookup on the backend.
  if(kzCustomer&&Array.isArray(kzCustomer.orders)&&kzCustomer.orders.length>0){
    state.loginEmail=kzCustomer.email;
    state.eligibleOrders=kzCustomer.orders;
    if(!restoredSession)state.step='orders';
    loadEligibility(); // async — marks each order eligible/ineligible, then re-renders
  }
  if(restoredSession&&state.step==='tracking')refreshReturnStatus();

  function isMobile(){return window.innerWidth<=600}
  function render(){
    saveReturnSession();
    if(!state.showCatalog)removeCatalogOverlay();
    var preservedY=typeof state._pageScrollY==='number'?state._pageScrollY:null;
    while(app.firstChild)app.removeChild(app.firstChild);
    var isChat=state.step==='chat';
    var wrap=el('div',{className:'kz-ret-wrap'+(isChat?' kz-ret-wrap--chat':'')});
    if(!(isChat&&isMobile())){
      wrap.appendChild(el('h1',{className:'kz-ret-title'},'Trocas e Devoluções'));
      wrap.appendChild(el('p',{className:'kz-ret-sub'},'Converse com nosso assistente para resolver'));
    }

    if(state.error&&!isChat){
      var err=el('div',{className:'kz-ret-error',role:'alert'});err.textContent=state.error;
      wrap.appendChild(err);
    }
    if(state.sessionRestored&&state.step!=='login'){
      var sessionResetButton=el('button',{style:'border:0;background:transparent;color:#0e7490;font-weight:700;font-size:12px;cursor:pointer;padding:2px 0;white-space:nowrap',onclick:resetSessionFlow},kzCustomer?'Escolher outro pedido':'Começar de novo');
      sessionResetButton.disabled=state.chatRequestInFlight;
      wrap.appendChild(el('div',{style:'display:flex;align-items:center;justify-content:space-between;gap:10px;background:#ecfeff;border:1px solid #a5f3fc;color:#0e7490;border-radius:8px;padding:9px 10px;font-size:12px;margin-bottom:10px;line-height:1.4'},[
        el('span',{},'Atendimento retomado nesta aba.'),
        sessionResetButton
      ]));
    }

    if(state.step==='login') renderLogin(wrap);
    else if(state.step==='tracking') renderTracking(wrap);
    else if(state.step==='orders') renderOrders(wrap);
    else if(state.step==='select_product') renderSelectProduct(wrap);
    else if(state.step==='chat') renderChat(wrap);

    app.appendChild(wrap);

    // Hide/show external chat widgets (Shopify, Tidio, etc.) when fullscreen chat is active
    if(isMobile()){
      var selectors=['#shopify-chat','#tidio-chat','.shopify-chat','.tidio-chat-code','iframe[title*="chat"]','iframe[title*="Chat"]','#chat-widget','[id*="tidio"]','[id*="shopify-chat"]','#ShopifyChat'];
      selectors.forEach(function(sel){
        try{
          var els=document.querySelectorAll(sel);
          els.forEach(function(e){e.style.display=isChat?'none':''});
        }catch(x){}
      });
    }
    if(preservedY!==null&&(!isChat||isMobile())){
      state._pageScrollY=null;
      window.scrollTo(0,preservedY);
    }
    setPageScrollLocked(isChat&&isMobile());
    if(preservedY!==null){
      setTimeout(function(){
        if(isChat&&!isMobile()){
          wrap.scrollIntoView({block:'start',behavior:'smooth'});
        }
        positionChatScrollButton();
        state._pageScrollY=null;
        if(isChat)state._chatTransitionScrollY=null;
      },0);
    }
  }

  /* ── Login (guest: email + order number) ── */
  // Guests must prove ownership with BOTH email and order number — email alone is
  // not a secret. Logged-in customers never see this form (they start on their
  // order list, bootstrapped from the authenticated Shopify session).
  function renderLogin(wrap){
    var card=el('div',{className:'kz-ret-card'},[
      el('div',{style:'margin-bottom:12px'},[
        el('label',{className:'kz-ret-label'},'Email usado na compra'),
        el('input',{className:'kz-ret-input',id:'kz-email',type:'email',placeholder:'seu@email.com',onkeydown:function(e){if(e.key==='Enter')startChat()}})
      ]),
      el('div',{style:'margin-bottom:12px'},[
        el('label',{className:'kz-ret-label'},'Número do pedido'),
        el('input',{className:'kz-ret-input',id:'kz-order',type:'text',inputmode:'numeric',placeholder:'Ex: 123456',onkeydown:function(e){if(e.key==='Enter')startChat()}})
      ]),
      el('div',{style:'font-size:12px;color:#6b7280;line-height:1.45;margin:-2px 0 12px'},'Usamos email e número do pedido para proteger seus dados.'),
      el('button',{className:'kz-ret-btn kz-ret-btn-primary',id:'kz-start',onclick:startChat},
        state.sending?'Verificando...':'Iniciar conversa')
    ]);
    if(state.sending){var b=card.querySelector('#kz-start');if(b)b.disabled=true}
    // Pre-fill email for logged-in customers who reach this form (order still required)
    if(kzCustomer&&kzCustomer.email){
      setTimeout(function(){var inp=$('kz-email');if(inp&&!inp.value)inp.value=kzCustomer.email},0);
    }
    wrap.appendChild(card);
  }

  function startChat(){
    var email=(($('kz-email')||{}).value||'').trim();
    var orderNumber=(($('kz-order')||{}).value||'').replace(/[^0-9]/g,'');
    if(!email){state.error='Informe seu email';render();return}
    if(!orderNumber){state.error='Informe o número do pedido';render();return}
    clearReturnSession();
    state.error='';
    state.sessionRestored=false;
    state.loginEmail=email;
    // selectOrder runs the secure email+order lookup and routes to tracking or chat
    selectOrder({number:orderNumber});
  }

  function addBotMsg(text,meta){
    var msg={role:'assistant',content:text};
    if(meta&&Array.isArray(meta.product_cards)){
      var cards=cleanProductCards(meta.product_cards);
      if(cards.length)msg.product_cards=cards;
    }
    if(meta&&meta.product_prompt)msg.product_prompt=cleanText(meta.product_prompt,500);
    state.history.push(msg);
  }
  function addUserMsg(text){state.history.push({role:'user',content:text})}

  var pageScrollLock={locked:false,y:0};
  function preventLockedPageScroll(e){
    var chat=document.querySelector('.kz-ret-chat');
    var catalog=document.querySelector('.kz-ret-catalog');
    var media=document.querySelector('.kz-ret-media-dialog');
    if((chat&&chat.contains(e.target))||(catalog&&catalog.contains(e.target))||(media&&media.contains(e.target)))return;
    e.preventDefault();
  }
  function setPageScrollLocked(locked){
    if(locked){
      if(pageScrollLock.locked)return;
      pageScrollLock.locked=true;
      pageScrollLock.y=pageScrollY();
      document.documentElement.classList.add('kz-ret-page-locked');
      document.body.classList.add('kz-ret-page-locked');
      document.addEventListener('touchmove',preventLockedPageScroll,{passive:false});
      document.addEventListener('wheel',preventLockedPageScroll,{passive:false});
      return;
    }
    if(!pageScrollLock.locked)return;
    var y=pageScrollLock.y||0;
    pageScrollLock.locked=false;
    document.documentElement.classList.remove('kz-ret-page-locked');
    document.body.classList.remove('kz-ret-page-locked');
    document.removeEventListener('touchmove',preventLockedPageScroll);
    document.removeEventListener('wheel',preventLockedPageScroll);
    window.scrollTo(0,y);
  }

  /* ── Chat ── */
  /* ── Tracking page ── */
  var STEP_LABELS={pending:'Solicitação enviada',approved:'Aprovada',label_generated:'Código gerado',shipped:'Enviado',received:'Recebido',reshipped:'Reenvio',completed:'Concluído',rejected:'Não aprovada',cancelled:'Cancelada'};
  var STEP_ORDER=['pending','approved','label_generated','shipped','received','completed'];

  function renderTracking(wrap){
    var rets=state.existingReturns||[];
    var card=el('div',{className:'kz-ret-card'});
    var title=el('div',{style:'font-weight:700;font-size:15px;margin-bottom:12px'});title.textContent='Minhas Devoluções';
    card.appendChild(title);

    if(rets.length===0){
      var empty=el('div',{style:'color:#6b7280;font-size:13px;text-align:center;padding:20px'});empty.textContent='Nenhuma devolução encontrada.';
      card.appendChild(empty);
    }

    rets.forEach(function(r){
      var box=el('div',{style:'border:1px solid #e5e7eb;border-radius:10px;padding:14px;margin-bottom:12px'});

      // Header
      var returnProductNames=Array.isArray(r.product_names)?r.product_names.map(function(name){return cleanText(String(name||''),500).trim()}).filter(Boolean):[];
      var head=el('div',{style:'display:flex;align-items:center;justify-content:space-between;margin-bottom:8px'});
      var prodName=el('div',{style:'font-weight:600;font-size:13px'});
      prodName.textContent=returnProductNames.length>1?returnProductNames.length+' produtos na solicitação':(returnProductNames[0]||r.product_name);
      var badge=el('span',{className:'kz-ret-badge kz-ret-badge-'+(r.status||'pending')});badge.textContent=STEP_LABELS[r.status]||r.status;
      head.appendChild(prodName);head.appendChild(badge);
      box.appendChild(head);

      if(returnProductNames.length>1){
        var returnedProducts=el('div',{className:'kz-ret-tracking-products'});
        returnProductNames.slice(0,6).forEach(function(name){returnedProducts.appendChild(el('div',{},'• '+name))});
        if(returnProductNames.length>6)returnedProducts.appendChild(el('div',{},'+ '+(returnProductNames.length-6)+' outro(s)'));
        box.appendChild(returnedProducts);
      }

      var replacementName=cleanText(String(r.replacement_product_name||''),500).trim();
      if(replacementName){
        var replacement=el('div',{className:'kz-ret-replacement-summary'});
        replacement.appendChild(el('strong',{},'Produto da reposição'));
        replacement.appendChild(document.createTextNode(replacementName));
        box.appendChild(replacement);
      }

      // Status message
      if(r.status_message){
        var msg=el('div',{style:'font-size:12px;color:#374151;margin-bottom:10px;line-height:1.5'});msg.textContent=r.status_message;
        box.appendChild(msg);
      }

      // Tracking code — reverse logistics (Correios)
      if(r.tracking_code && (r.status==='label_generated'||r.status==='shipped')){
        var trackBox=el('div',{style:'background:#e6fafb;border:1px solid #a5e8ef;border-radius:8px;padding:10px;margin-bottom:10px;text-align:center'});
        var trackLabel=el('div',{style:'font-size:11px;color:#0e9bab;margin-bottom:4px'});trackLabel.textContent=r.status==='label_generated'?'Código para informar na agência:':'Código de rastreio da devolução:';
        var trackCode=el('div',{className:'kz-ret-trackbox-code',onclick:function(){navigator.clipboard.writeText(r.tracking_code);trackCode.textContent=r.tracking_code+' ✓';setTimeout(function(){trackCode.textContent=r.tracking_code},2000)}});
        trackCode.textContent=r.tracking_code;
        trackBox.appendChild(trackLabel);trackBox.appendChild(trackCode);
        if(r.tracking_url){
          var trackLink=el('a',{href:r.tracking_url,target:'_blank',style:'font-size:11px;color:#17d4e6;display:block;margin-top:4px'});trackLink.textContent='Rastrear no site dos Correios';
          trackBox.appendChild(trackLink);
        }
        box.appendChild(trackBox);

        // Wait warning — label_generated só nas primeiras 2h (sistema dos Correios precisa liberar)
        if(r.status==='label_generated'){
          var labelAt=null;
          if(r.status_history && r.status_history.length){
            for(var shi=r.status_history.length-1;shi>=0;shi--){
              if(r.status_history[shi].status==='label_generated'){labelAt=r.status_history[shi].timestamp;break}
            }
          }
          if(!labelAt) labelAt=r.updated_at||r.created_at;
          var ageMin=labelAt?Math.floor((Date.now()-new Date(labelAt).getTime())/60000):999;
          if(ageMin<120){
            var remainMin=Math.max(0,120-ageMin);
            var waitBox=el('div',{style:'background:#fffbeb;border-left:3px solid #f59e0b;border-radius:6px;padding:10px 12px;margin-bottom:10px;color:#92400e;font-size:12px;line-height:1.5;text-align:left'});
            var waitTitle=el('div',{style:'font-weight:600;margin-bottom:2px;font-size:12px'});waitTitle.textContent='Aguarde antes de ir à agência';
            var waitMsg=el('div');
            if(remainMin>60){waitMsg.textContent='Os Correios podem levar até ~'+Math.ceil(remainMin/60)+'h para liberar seu código. Se for antes, a postagem pode ser recusada.';}
            else if(remainMin>10){waitMsg.textContent='Faltam ~'+remainMin+' min para liberar no sistema dos Correios. Se for antes, a postagem pode ser recusada.';}
            else {waitMsg.textContent='Só mais alguns minutos para liberar no sistema dos Correios.';}
            waitBox.appendChild(waitTitle);waitBox.appendChild(waitMsg);
            box.appendChild(waitBox);
          }
        }
      }

      // Tracking code — reship (new product sent to customer)
      if(r.reship_tracking_code && r.has_reship){
        var rTrackBox=el('div',{style:'background:#f0fdf4;border:1px solid #bbf7d0;border-radius:8px;padding:10px;margin-bottom:10px;text-align:center'});
        var rTrackLabel=el('div',{style:'font-size:11px;color:#166534;margin-bottom:4px'});
        rTrackLabel.textContent=r.reship_shipment_status==='delivered'?'Novo produto entregue! Rastreio:':'Rastreio do novo produto:';
        var rTrackCode=el('div',{style:'font-family:monospace;font-size:15px;font-weight:700;color:#166534;cursor:pointer;padding:4px',onclick:function(){navigator.clipboard.writeText(r.reship_tracking_code);rTrackCode.textContent=r.reship_tracking_code+' ✓';setTimeout(function(){rTrackCode.textContent=r.reship_tracking_code},2000)}});
        rTrackCode.textContent=r.reship_tracking_code;
        rTrackBox.appendChild(rTrackLabel);rTrackBox.appendChild(rTrackCode);
        box.appendChild(rTrackBox);
      }

      // Troubleshooting
      if(r.troubleshooting&&r.troubleshooting.length>0){
        var tsBox=el('div',{style:'background:#fffbeb;border:1px solid #fde68a;border-radius:8px;padding:10px;margin-bottom:10px'});
        var tsList=el('ol',{style:'margin:0;padding-left:18px;font-size:12px;color:#78350f'});
        r.troubleshooting.forEach(function(t){var li=el('li',{style:'margin-bottom:3px'});li.textContent=t;tsList.appendChild(li)});
        tsBox.appendChild(tsList);
        box.appendChild(tsBox);
      }

      // Refund
      if(r.refund){
        var refBox=el('div',{style:'background:#f0fdf4;border:1px solid #bbf7d0;border-radius:8px;padding:10px;margin-bottom:10px;font-size:12px;color:#166534'});
        refBox.textContent='Reembolso de R$'+parseFloat(r.refund.amount).toFixed(2)+' processado em '+new Date(r.refund.date).toLocaleDateString('pt-BR');
        box.appendChild(refBox);
      }

      // Rejection
      if(r.status==='rejected'&&r.rejection_reason){
        var rejBox=el('div',{style:'background:#fef2f2;border:1px solid #fecaca;border-radius:8px;padding:10px;margin-bottom:10px;font-size:12px;color:#991b1b'});
        rejBox.textContent=r.rejection_reason;
        box.appendChild(rejBox);
      }

      // Mini timeline — adapts steps based on return type + reship fulfillment status
      var isReship=r.status==='reshipped'||r.has_reship;
      var isNoReturn=r.no_return;
      var reshipStatus=r.reship_shipment_status||'';
      var steps;
      if(isNoReturn&&isReship){
        steps=[{key:'pending',label:'Solicitação'},{key:'approved',label:'Aprovada'},{key:'reshipped',label:'Reenvio'},{key:'reship_dispatched',label:'Despachado'},{key:'reship_delivered',label:'Entregue'}];
      } else if(isNoReturn){
        steps=[{key:'pending',label:'Solicitação'},{key:'approved',label:'Aprovada'},{key:'completed',label:'Concluído'}];
      } else if(isReship){
        steps=[{key:'pending',label:'Solicitação'},{key:'approved',label:'Aprovada'},{key:'label_generated',label:'Postagem'},{key:'shipped',label:'Enviado'},{key:'received',label:'Recebido'},{key:'reshipped',label:'Reenvio'},{key:'reship_dispatched',label:'Despachado'},{key:'reship_delivered',label:'Entregue'}];
      } else {
        steps=[{key:'pending',label:'Solicitação'},{key:'approved',label:'Aprovada'},{key:'label_generated',label:'Postagem'},{key:'shipped',label:'Enviado'},{key:'received',label:'Recebido'},{key:'completed',label:'Concluído'}];
      }
      // Determine current step index
      var currentIdx=0;
      for(var si=0;si<steps.length;si++){if(steps[si].key===r.status){currentIdx=si;break}}
      // Advance past reshipped based on fulfillment status
      if(r.status==='reshipped'&&isReship){
        var reshipIdx=currentIdx;
        if(reshipStatus==='fulfilled'||reshipStatus==='in_transit'||r.reship_tracking_code){
          for(var ri=reshipIdx+1;ri<steps.length;ri++){if(steps[ri].key==='reship_dispatched'){currentIdx=ri;break}}
        }
        if(reshipStatus==='delivered'){
          for(var ri2=reshipIdx+1;ri2<steps.length;ri2++){if(steps[ri2].key==='reship_delivered'){currentIdx=ri2;break}}
        }
      }
      if(r.status==='completed'){currentIdx=steps.length-1}
      if(r.status==='cancelled'||r.status==='rejected')currentIdx=-1;

      var timeline=el('div',{style:'display:flex;align-items:center;gap:0;margin-top:10px;overflow-x:auto'});
      steps.forEach(function(st,i){
        var reached=currentIdx>=0&&i<=currentIdx;
        var isCurrent=i===currentIdx;
        var stepEl=el('div',{style:'display:flex;flex-direction:column;align-items:center;flex-shrink:0'});
        var dot=el('div',{style:'width:22px;height:22px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:700;'+(isCurrent?'background:#17d4e6;color:#fff;box-shadow:0 0 0 3px rgba(23,212,230,.25)':reached?'background:#17d4e6;color:#fff':'background:#e5e7eb;color:#9ca3af')});
        dot.textContent=isCurrent?'✓':String(i+1);
        var label=el('div',{style:'font-size:8px;margin-top:3px;color:'+(reached?'#17d4e6':'#9ca3af')+';white-space:nowrap;font-weight:'+(isCurrent?'700':'400')});
        label.textContent=st.label;
        stepEl.appendChild(dot);stepEl.appendChild(label);
        timeline.appendChild(stepEl);
        if(i<steps.length-1){
          var line=el('div',{style:'width:16px;height:2px;flex-shrink:0;margin-top:-12px;'+(currentIdx>=0&&i<currentIdx?'background:#17d4e6':'background:#e5e7eb')});
          timeline.appendChild(line);
        }
      });
      box.appendChild(timeline);

      // Date
      var dateDiv=el('div',{style:'font-size:10px;color:#9ca3af;margin-top:6px'});dateDiv.textContent='Solicitado em '+new Date(r.created_at).toLocaleDateString('pt-BR');
      box.appendChild(dateDiv);

      card.appendChild(box);
    });

    // Resume chat button (if user came back from chat)
    if(state._chatSnapshot&&state._chatSnapshot.history.length>0){
      var resumeBtn=el('button',{className:'kz-ret-btn kz-ret-btn-primary',style:'margin-top:12px',onclick:function(){var snap=state._chatSnapshot;beginChatTransition();resetAttachmentFlow();state.sending=false;state.activityLabel='';state.history=snap.history;state.returnContext=snap.returnContext;state.selectedProduct=snap.selectedProduct;state.selectedLineItemIds=cleanSelectedLineItemIds(snap.selectedLineItemIds,state.orderItems);state.selectedOrder=snap.selectedOrder;state.returnCreated=snap.returnCreated;state.returnCompleted=snap.returnCompleted;state.historyLoaded=snap.historyLoaded;state.images=snap.images;state.accumulatedImageUrls=snap.accumulatedImageUrls;state.showAddress=snap.showAddress;state.addressData=snap.addressData;state._chatSnapshot=null;state.step='chat';render()}},'Continuar conversa');
      card.appendChild(resumeBtn);
    }
    // Button to start new request
    var btnRow=el('div',{style:'display:flex;gap:8px;margin-top:12px'},[
      el('button',{className:'kz-ret-btn kz-ret-btn-secondary',onclick:function(){resetSessionFlow()}},'Voltar'),
      el('button',{className:'kz-ret-btn kz-ret-btn-primary',onclick:function(){selectOrder({number:state.selectedOrder,items:state.orderItems},true)}},'Nova solicitação')
    ]);
    card.appendChild(btnRow);
    wrap.appendChild(card);
  }

  /* ── Order Selection ── */
  // Ask the backend which of the customer's orders are eligible for a return.
  // Sends only the order numbers we already have (from the Shopify session) — the
  // backend never returns the customer's list, just eligible/reason per number.
  // On failure we leave eligibility null and every order stays actionable.
  function loadEligibility(){
    var orders=state.eligibleOrders||[];
    if(orders.length===0)return;
    state.eligibilityLoading=true;
    fetch(API+'/api/returns/public/eligibility',{
      method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({email:state.loginEmail,order_numbers:orders.map(function(o){return String(o.number)})})
    }).then(function(r){return r.ok?r.json():null}).then(function(d){
      state.eligibilityLoading=false;
      if(d&&Array.isArray(d.orders)){
        var map={};
        d.orders.forEach(function(e){map[String(e.number)]=e});
        state.orderEligibility=map;
      }
      render();
    }).catch(function(){state.eligibilityLoading=false;render()});
  }

  function orderCard(o,opts){
    var clickable=opts.clickable;
    var base='border:1px solid #e5e7eb;border-radius:10px;padding:14px;margin-bottom:8px;';
    var oCard=el(clickable?'button':'div',{className:clickable?'kz-ret-order-card':'',style:base+(clickable?'cursor:pointer;transition:border-color .2s':'opacity:.7;background:#f9fafb')});
    if(clickable){
      oCard.setAttribute('type','button');
      oCard.disabled=state.sending;
      oCard.onmouseenter=function(){oCard.style.borderColor='#17d4e6'};
      oCard.onmouseleave=function(){oCard.style.borderColor='#e5e7eb'};
      oCard.onclick=function(){selectOrder(o)};
    }
    var head=el('span',{style:'display:flex;justify-content:space-between;align-items:center;gap:8px;margin-bottom:6px'});
    var num=el('span',{style:'font-weight:600;font-size:14px;color:#1a1a2e'});num.textContent='Pedido #'+o.number;
    head.appendChild(num);
    if(!clickable&&opts.reason){
      var badge=el('span',{style:'font-size:11px;color:#92400e;background:#fef3c7;border:1px solid #fde68a;border-radius:10px;padding:2px 8px;white-space:nowrap'});
      badge.textContent=opts.reason;
      head.appendChild(badge);
    } else {
      var date=el('span',{style:'font-size:11px;color:#9ca3af;white-space:nowrap'});
      date.textContent=o.created_at||''; // já vem formatado (dd/mm/aaaa) do Liquid
      head.appendChild(date);
    }
    oCard.appendChild(head);
    // Preview of the items (a full order can have many line items)
    var allItems=o.items||[];
    allItems.slice(0,6).forEach(function(item){
      var li=el('span',{style:'display:block;font-size:12px;color:#4b5563;padding:2px 0'});
      li.textContent='• '+item.product_name+(item.quantity>1?' (x'+item.quantity+')':'');
      oCard.appendChild(li);
    });
    if(allItems.length>6){
      var more=el('span',{style:'display:block;font-size:12px;color:#9ca3af;padding:2px 0'});
      more.textContent='+ mais '+(allItems.length-6)+' item(ns)';
      oCard.appendChild(more);
    }
    return oCard;
  }

  function renderOrders(wrap){
    var orders=state.eligibleOrders||[];
    var card=el('div',{className:'kz-ret-card'});

    if(kzCustomer&&kzCustomer.first_name){
      var greeting=el('div',{style:'font-size:14px;color:#374151;margin-bottom:12px'});
      greeting.textContent='Olá, '+toTitleCase(kzCustomer.first_name)+'!';
      card.appendChild(greeting);
    }

    var title=el('div',{style:'font-weight:700;font-size:15px;margin-bottom:4px'});
    title.textContent='Selecione o pedido';
    card.appendChild(title);

    var sub=el('div',{style:'font-size:12px;color:#666;margin-bottom:16px'});
    sub.textContent='Qual pedido deseja solicitar troca ou devolução?';
    card.appendChild(sub);

    // Still checking eligibility → skeleton (avoids reshuffle flicker)
    if(state.eligibilityLoading&&!state.orderEligibility){
      var checking=el('div',{style:'text-align:center;padding:24px;color:#9ca3af;font-size:13px'});
      checking.textContent='Carregando seus pedidos...';
      card.appendChild(checking);
      wrap.appendChild(card);
      return;
    }

    if(orders.length===0){
      var empty=el('div',{style:'text-align:center;padding:20px;color:#6b7280;font-size:13px;line-height:1.6'});
      empty.textContent='Nenhum pedido encontrado na sua conta.';
      card.appendChild(empty);
    }

    if(state.sending){
      var loading=el('div',{style:'text-align:center;padding:20px;color:#666;font-size:13px'});
      loading.textContent='Carregando pedido...';
      card.appendChild(loading);
    }

    // Partition by eligibility. If eligibility is unknown (still loading or the
    // check failed), every order stays actionable — the backend re-checks on click.
    var elig=state.orderEligibility;
    var actionable=[],blocked=[];
    orders.forEach(function(o){
      var e=elig?elig[String(o.number)]:null;
      if(elig&&e&&e.eligible===false)blocked.push({o:o,reason:e.reason});
      else actionable.push(o);
    });

    if(actionable.length===0&&blocked.length>0){
      var none=el('div',{style:'padding:12px 14px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;color:#6b7280;font-size:13px;line-height:1.5;margin-bottom:12px'});
      none.textContent='Nenhum dos seus pedidos está elegível para troca ou devolução no momento — veja os motivos abaixo.';
      card.appendChild(none);
    }

    actionable.forEach(function(o){card.appendChild(orderCard(o,{clickable:true}))});

    if(blocked.length>0){
      var sep=el('div',{style:'font-size:12px;color:#9ca3af;font-weight:600;margin:16px 0 8px'});
      sep.textContent='Fora do prazo para troca ou devolução';
      card.appendChild(sep);
      blocked.forEach(function(b){card.appendChild(orderCard(b.o,{clickable:false,reason:b.reason}))});
    }

    // Logged-in customers land here directly (their order list is home) — no "back".
    // A guest who reaches this view can still return to the identify form.
    if(!kzCustomer){
      var backBtn=el('button',{className:'kz-ret-btn kz-ret-btn-secondary',style:'margin-top:8px',onclick:resetSessionFlow},'Voltar');
      card.appendChild(backBtn);
    }
    wrap.appendChild(card);
  }

  function loadChatHistory(orderNumber,callback){
    var url=API+'/api/returns/public/history?token='+encodeURIComponent(state.auth.token)+'&payload='+encodeURIComponent(state.auth.payload)+'&order='+encodeURIComponent(orderNumber);
    fetch(url).then(function(r){return r.json()}).then(function(data){
      if(data.returns){
        var messages=[];var latestStatus=null;
        data.returns.forEach(function(ret){
          if(!latestStatus)latestStatus=ret.status;
          (ret.chat_history||[]).forEach(function(msg){msg.old=true;messages.push(msg)});
        });
        if(messages.length>0){
          messages.sort(function(a,b){return(a.ts||0)-(b.ts||0)});
          state.history=messages;state.historyLoaded=true;
        }
        if(latestStatus==='completed'||latestStatus==='rejected')state.returnCompleted=true;
      }
      callback();
    }).catch(function(){callback()});
  }

  function refreshReturnStatus(){
    if(!state.auth||!state.auth.token||!state.auth.payload)return;
    var statusUrl=API+'/api/returns/public/status?token='+encodeURIComponent(state.auth.token)+'&payload='+encodeURIComponent(state.auth.payload);
    fetch(statusUrl).then(function(r){return r.json().then(function(d){return{ok:r.ok,data:d}})})
    .then(function(res){
      if(!res.ok){handleAuthSessionError(res.data&&res.data.error);return}
      if(res.data&&res.data.returns&&res.data.returns.length>0)state.existingReturns=res.data.returns;
      render();
    }).catch(function(){});
  }

  function renderSelectProduct(wrap){
    var card=el('div',{className:'kz-ret-card'});
    card.appendChild(el('div',{style:'font-weight:700;font-size:15px;margin-bottom:8px;color:#1a1a2e'},'Quais produtos têm problema?'));
    card.appendChild(el('div',{style:'font-size:12px;color:#9ca3af;margin-bottom:12px'},'Pedido #'+state.selectedOrder+' — selecione um ou mais'));

    var checked={};
    var confirmBtn;

    state.orderItems.forEach(function(item,idx){
      var row=el('label',{style:'display:flex;align-items:center;gap:10px;padding:12px 14px;margin-bottom:6px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;cursor:pointer;font-size:13px;color:#1a1a2e;transition:all .15s'});
      var cb=el('input',{type:'checkbox',style:'width:18px;height:18px;accent-color:#6366f1;cursor:pointer;flex-shrink:0'});
      cb.onchange=function(){
        checked[idx]=this.checked;
        var any=Object.keys(checked).some(function(k){return checked[k]});
        row.style.borderColor=this.checked?'#6366f1':'#e2e8f0';
        row.style.background=this.checked?'#eef2ff':'#f8fafc';
        if(confirmBtn)confirmBtn.disabled=!any;
        if(confirmBtn)confirmBtn.style.opacity=any?'1':'0.5';
      };
      var label=el('span',{});label.textContent=item.product_name+(item.quantity>1?' (x'+item.quantity+')':'');
      row.appendChild(cb);row.appendChild(label);
      card.appendChild(row);
    });

    confirmBtn=el('button',{
      className:'kz-ret-btn kz-ret-btn-primary',
      style:'margin-top:12px;width:100%;opacity:0.5',
      disabled:true,
      onclick:function(){
        var selectedItems=[];
        state.orderItems.forEach(function(item,idx){if(checked[idx])selectedItems.push(item)});
        var selected=selectedItems.map(function(item){return item.product_name});
        if(selected.length===0)return;
        var selectedLineItemIds=selectedItems.map(function(item){return String(item.line_item_id||'').trim()}).filter(Boolean);
        if(selectedLineItemIds.length!==selectedItems.length){
          state.error='Não foi possível validar os itens deste pedido. Atualize a página e tente novamente.';
          render();return;
        }
        state.selectedProduct=selected.join(' | ');
        state.selectedLineItemIds=selectedLineItemIds;
        function openAfterSelect(){
          beginChatTransition();
          state.step='chat';
          if(!state.historyLoaded){
            addBotMsg('Pedido #'+state.selectedOrder+'. '+(selected.length>1?'Produtos selecionados:':'Produto selecionado:'),{
              product_cards:productCardsFromItems(selectedItems),
              product_prompt:'Qual o problema? Me conte o que aconteceu.'
            });
          }
          render();
        }
        openAfterSelect();
      }
    },'Continuar');
    card.appendChild(confirmBtn);

    var backBtn=el('button',{className:'kz-ret-btn kz-ret-btn-secondary',style:'margin-top:8px',onclick:function(){
      resetSessionFlow();
    }},'← Voltar');
    card.appendChild(backBtn);
    wrap.appendChild(card);
  }

  function selectOrder(order,newRequest){
    if(state.chatRequestInFlight||state.sending)return;
    beginChatTransition();
    resetAttachmentFlow();
    var lookupFlow=attachmentFlow;
    var localItems=Array.isArray(order.items)?order.items:[];
    state.images=[];
    state.sending=true;state.error='';render();
    fetch(API+'/api/returns/public/lookup',{
      method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({email:state.loginEmail,order_number:String(order.number)})
    }).then(function(r){return r.json().then(function(d){return{ok:r.ok,data:d}})})
    .then(function(res){
      if(!isCurrentAttachmentFlow(lookupFlow))return;
      state.sending=false;
      if(!res.ok){state.error=res.data.error||'Erro';render();return}
      var lookupTokenData=parseAuthPayload(res.data&&res.data.auth);
      if(!lookupTokenData||!lookupTokenData.sessionId||typeof lookupTokenData.sessionId!=='string'){
        state.auth=null;
        state.error='Não foi possível iniciar uma sessão segura. Atualize a página e tente novamente.';
        render();return;
      }
      state.auth=res.data.auth;state.error='';
      state.selectedOrder=res.data.order?res.data.order.number:order.number;
      state.orderItems=res.data.order?mergeOrderItemsWithLocalImages(res.data.order.items,localItems):cleanOrderItemsForStorage(localItems);
      state.history=[];state.historyLoaded=false;state.returnCompleted=false;state.selectedProduct=null;state.selectedLineItemIds=[];state.catalogSelectedProduct=null;state.catalogReopenAvailable=false;

      // Existing return(s) for this order → show the status/tracking view
      if(!newRequest&&res.data.existing_returns&&res.data.existing_returns.length>0){
        state.existingReturns=res.data.existing_returns;
        // Enrich with the status endpoint (refund, timeline, tracking URL). The
        // order-bound token already carries email+order, so no query params needed.
        state.step='tracking';
        refreshReturnStatus();
        render();return;
      }

      // No existing return → start a new one
      startNewReturn();
    }).catch(function(){if(!isCurrentAttachmentFlow(lookupFlow))return;state.sending=false;state.error='Erro de conexão';render()});
  }

  // Begin a new return for the already-looked-up order (uses state.orderItems).
  function startNewReturn(){
    if(state.chatRequestInFlight)return;
    resetAttachmentFlow();
    state.images=[];
    state.accumulatedImageUrls=[];state.returnContext=null;state.addressData=null;state.addressMode=null;state.showAddress=false;state._draftText='';state._chatSnapshot=null;
    state.history=[];state.historyLoaded=false;state.returnCreated=false;state.returnCompleted=false;state.selectedProduct=null;state.selectedLineItemIds=[];state.catalogSelectedProduct=null;state.catalogReopenAvailable=false;
    // Auto-select when the order has a single eligible item
    if(state.orderItems.length===1){
      var singleLineItemId=String(state.orderItems[0].line_item_id||'').trim();
      if(!singleLineItemId){
        state.error='Não foi possível validar os itens deste pedido. Atualize a página e tente novamente.';
        state.step=kzCustomer?'orders':'login';render();return;
      }
      state.selectedProduct=state.orderItems[0].product_name;
      state.selectedLineItemIds=[singleLineItemId];
    }
    // Multiple items → let the customer choose which ones have a problem
    if(state.orderItems.length>1){state.step='select_product';render();return}
    rememberPageScrollForRender();
    state.step='chat';
    if(state.selectedProduct){
      addBotMsg('Pedido #'+state.selectedOrder+'. Produto selecionado:',{
        product_cards:productCardsFromItems([state.orderItems[0]]),
        product_prompt:'Qual o problema? Me conte o que aconteceu.'
      });
    } else {
      addBotMsg('Olá! Como posso ajudar com sua troca ou devolução?');
    }
    render();
  }

  /* ── Chat ── */
  function renderProductCards(parent,cards){
    cards=cleanProductCards(cards);
    if(!cards.length)return;
    var list=el('div',{className:'kz-ret-product-list'});
    cards.forEach(function(card){
      var row=el('div',{className:'kz-ret-product-card'});
      if(card.image){
        var img=el('img',{className:'kz-ret-product-img',src:card.image,alt:card.name});
        img.loading='lazy';
        row.appendChild(img);
      }
      var info=el('div',{className:'kz-ret-product-info'});
      info.appendChild(el('div',{className:'kz-ret-product-name'},card.name));
      if(card.quantity)info.appendChild(el('div',{className:'kz-ret-product-meta'},'Quantidade: '+card.quantity));
      row.appendChild(info);
      list.appendChild(row);
    });
    parent.appendChild(list);
  }

  function selectionKey(selection){
    selection=cleanCatalogSelection(selection);
    return selection?(selection.handle+'::'+selection.variant_id):'';
  }

  function actionEndsExchangeSelection(action){
    var type=action&&action.type;
    return type==='return_created'||type==='reject'||type==='confirm_delivery_address'||type==='need_address';
  }

  function removePendingSelection(pendingMessage){
    if(!pendingMessage)return;
    var pendingIndex=state.history.indexOf(pendingMessage);
    if(pendingIndex!==-1)state.history.splice(pendingIndex,1);
  }

  function clearSelectedExchange(pendingMessage){
    state.catalogSelectedProduct=null;
    state.catalogReopenAvailable=false;
    state.history=state.history.filter(function(message){
      return message!==pendingMessage&&!cleanCatalogSelection(message&&message.product_selection);
    });
  }

  function addMultiExchangeNotice(){
    var notice='Para trocas de vários itens, nossa equipe confirmará cada produto e modelo com você durante a análise.';
    var alreadyShown=state.history.some(function(message){return message&&message.role==='notification'&&message.content===notice});
    if(!alreadyShown)state.history.push({role:'notification',content:notice});
  }

  function syncExchangeResponse(data,pendingMessage,successfulFallback){
    data=data&&typeof data==='object'?data:{};
    if(data.selected_exchange)return syncSelectedExchange(data.selected_exchange,pendingMessage);
    if(actionEndsExchangeSelection(data.action)){
      clearSelectedExchange(pendingMessage);
      return null;
    }
    if(data.action&&data.action.type==='error'){
      removePendingSelection(pendingMessage);
      return null;
    }
    return successfulFallback?syncSelectedExchange(successfulFallback,pendingMessage):null;
  }

  function syncSelectedExchange(rawSelection,pendingMessage){
    var selection=cleanCatalogSelection(rawSelection);
    if(!selection)return null;
    state.catalogSelectedProduct=selection;
    state.catalogReopenAvailable=false;
    var key=selectionKey(selection);
    var existing=null;
    for(var i=state.history.length-1;i>=0;i--){
      var candidate=state.history[i];
      if(candidate&&candidate.product_selection)candidate.product_selection_inactive=selectionKey(candidate.product_selection)!==key;
      if(!existing&&candidate!==pendingMessage&&selectionKey(candidate&&candidate.product_selection)===key)existing=candidate;
    }
    if(existing){
      existing.product_selection=selection;
      existing.product_selection_inactive=false;
      existing.content='';
      if(pendingMessage){
        var pendingIndex=state.history.indexOf(pendingMessage);
        if(pendingIndex!==-1)state.history.splice(pendingIndex,1);
      }
    }else if(pendingMessage){
      pendingMessage.content='';
      pendingMessage.product_selection=selection;
      pendingMessage.product_selection_inactive=false;
    }else{
      state.history.push({role:'user',content:'',product_selection:selection});
    }
    return selection;
  }

  function shouldShowCatalogReopen(){
    return state.catalogReopenAvailable===true&&
      state.step==='chat'&&
      state.selectedLineItemIds.length===1&&
      !state.catalogSelectedProduct&&
      !state.returnCreated&&
      !state.returnCompleted&&
      !state.showAddress&&
      !state.showCatalog;
  }

  function renderExchangeSelection(parent,rawSelection,inactive){
    var selection=cleanCatalogSelection(rawSelection);
    if(!selection)return;
    var card=el('div',{className:'kz-ret-selection-card'+(inactive?' is-inactive':'')});
    card.appendChild(el('div',{className:'kz-ret-selection-label'},inactive?'Opção anterior':'✓ Opção selecionada para troca'));
    var body=el('div',{className:'kz-ret-selection-body'});
    if(selection.image){
      var img=el('img',{className:'kz-ret-selection-img',src:selection.image,alt:selection.product_name||'Produto escolhido'});
      img.loading='lazy';
      img.onerror=function(){
        if(!img.parentNode)return;
        var fallback=el('div',{className:'kz-ret-selection-placeholder','aria-hidden':'true'},'▧');
        img.parentNode.replaceChild(fallback,img);
      };
      body.appendChild(img);
    }else{
      body.appendChild(el('div',{className:'kz-ret-selection-placeholder','aria-hidden':'true'},'▧'));
    }
    var info=el('div',{className:'kz-ret-selection-info'});
    info.appendChild(el('div',{className:'kz-ret-selection-product'},selection.product_name||'Produto selecionado'));
    if(selection.variant_title)info.appendChild(el('div',{className:'kz-ret-selection-variant'},'Modelo: '+selection.variant_title));
    if(selection.price)info.appendChild(el('div',{className:'kz-ret-selection-price'},formatPriceBRL(selection.price)));
    body.appendChild(info);
    card.appendChild(body);
    parent.appendChild(card);
  }

  function renderChat(wrap){
    var canUseInput=!state.returnCreated&&!state.returnCompleted;
    var showCatalogReopen=canUseInput&&shouldShowCatalogReopen();
    var chatClass='kz-ret-chat'+(canUseInput?' kz-ret-chat--has-input':'')+(state.showAddress?' kz-ret-chat--has-address':'')+(showCatalogReopen?' kz-ret-chat--has-catalog':'');
    var chatBox=el('div',{className:chatClass});

    // Mobile fullscreen header
    if(isMobile()){
      var chatHeader=el('div',{style:'display:flex;align-items:center;gap:10px;padding:12px 16px;border-bottom:1px solid #e5e7eb;background:#fff;flex-shrink:0'});
      var backBtn=el('button',{style:'background:none;border:none;font-size:20px;cursor:pointer;color:#374151;padding:4px;min-width:44px;min-height:44px;display:flex;align-items:center;justify-content:center',onclick:function(){if(state.chatRequestInFlight)return;state._chatSnapshot={history:state.history.slice(),returnContext:state.returnContext,selectedProduct:state.selectedProduct,selectedLineItemIds:state.selectedLineItemIds.slice(),selectedOrder:state.selectedOrder,returnCreated:state.returnCreated,returnCompleted:state.returnCompleted,historyLoaded:state.historyLoaded,images:state.images.slice(),accumulatedImageUrls:state.accumulatedImageUrls.slice(),showAddress:state.showAddress,addressData:state.addressData};resetAttachmentFlow();state.sending=false;state.activityLabel='';if(state.existingReturns&&state.existingReturns.length>0){state.step='tracking'}else if(state.eligibleOrders&&state.eligibleOrders.length>0){state.step='orders'}else{state.step='login';state.autoLoginAttempted=false}render()}});
      backBtn.textContent='←';
      backBtn.disabled=state.chatRequestInFlight;
      chatHeader.appendChild(backBtn);
      chatHeader.appendChild(el('span',{style:'font-weight:700;font-size:16px;color:#1a1a2e'},'Trocas e Devoluções'));
      chatBox.appendChild(chatHeader);
    }

    // Messages area
    var msgsShell=el('div',{className:'kz-ret-msgs-shell'});
    var msgsDiv=el('div',{className:'kz-ret-msgs',id:'kz-msgs'});
    msgsDiv.onscroll=updateChatScrollButton;
    state.history.forEach(function(msg){
      if(msg.role==='notification'){
        var bubble=el('div',{className:'kz-ret-msg kz-ret-msg-notification'+(msg.old?' kz-ret-msg-old':'')});
        bubble.appendChild(document.createTextNode('📋 '));
        renderTextWithLinks(bubble,msg.content||'');
        msgsDiv.appendChild(bubble);
      } else if(msg.role==='assistant'){
        var bubble=el('div',{className:'kz-ret-msg kz-ret-msg-bot'+(msg.old?' kz-ret-msg-old':'')});
        renderTextWithLinks(bubble,msg.content||'');
        renderProductCards(bubble,msg.product_cards);
        if(msg.product_prompt){
          var prompt=el('div',{className:'kz-ret-product-prompt'});
          renderTextWithLinks(prompt,msg.product_prompt);
          bubble.appendChild(prompt);
        }
        msgsDiv.appendChild(bubble);
      } else if(msg.role==='user'){
        var messageSelection=cleanCatalogSelection(msg.product_selection);
        var bubble=el('div',{className:'kz-ret-msg kz-ret-msg-user'+(messageSelection?' kz-ret-msg-selection':'')+(msg.old?' kz-ret-msg-old':'')});
        if(msg.images&&msg.images.length>0){
          var imgWrap=el('div',{style:'display:flex;gap:6px;flex-wrap:wrap;margin-bottom:'+(msg.content?'6px':'0')});
          msg.images.forEach(function(src){
            var img=el('img',{src:src,className:'kz-ret-msg-media',alt:'Imagem enviada'});
            img.onclick=function(){openMediaPreview(src)};
            img.onkeydown=function(e){if(e.key==='Enter'||e.key===' '){e.preventDefault();openMediaPreview(src)}};
            img.onload=function(){keepChatPinnedIfNearBottom(msgsDiv)};
            img.setAttribute('tabindex','0');
            img.setAttribute('role','button');
            img.setAttribute('aria-label','Abrir imagem anexada');
            imgWrap.appendChild(img);
          });
          bubble.appendChild(imgWrap);
        }
        if(messageSelection)renderExchangeSelection(bubble,messageSelection,msg.product_selection_inactive===true);
        if(msg.content)bubble.appendChild(document.createTextNode(msg.content));
        msgsDiv.appendChild(bubble);
      } else if(msg.role==='system'){
        var bubble=el('div',{className:'kz-ret-msg kz-ret-msg-system'});
        bubble.textContent=msg.content;
        msgsDiv.appendChild(bubble);
      }
    });

    if(state.sending){
      msgsDiv.appendChild(el('div',{className:'kz-ret-typing'},state.activityLabel||'Digitando...'));
    }
    var scrollBtn=el('button',{className:'kz-ret-scroll-bottom',id:'kz-scroll-bottom',type:'button',onclick:function(){scrollChatToBottom(true)}},'↓');
    scrollBtn.setAttribute('aria-label','Ir para o fim da conversa');
    msgsShell.appendChild(msgsDiv);
    chatBox.appendChild(msgsShell);
    chatBox.appendChild(scrollBtn);
    if(state.error)chatBox.appendChild(el('div',{className:'kz-ret-error',role:'alert'},state.error));

    // Address form (shown when bot requests)
    if(state.showAddress){
      var af=el('div',{className:'kz-ret-addr-form',id:'kz-addr-form'});
      var aTitle=el('div',{style:'font-weight:600;font-size:12px;margin-bottom:8px;color:#0e9bab'});
      aTitle.textContent=state.addressMode==='delivery'?'Confirme o endereço para receber o produto de troca:':'Confirme seu endereço:';
      af.appendChild(aTitle);
      var a=state.addressData||{};
      af.appendChild(makeInput('kz-a-addr','Endereço',a.address||''));
      var row=el('div',{className:'kz-ret-addr-row'},[
        makeInput('kz-a-city','Cidade',a.city||''),
        makeInput('kz-a-state','UF',a.state||''),
        makeInput('kz-a-zip','CEP',a.zip||''),
      ]);
      af.appendChild(row);
      af.appendChild(makeInput('kz-a-phone','Telefone',a.phone||''));
      var abtn=el('div',{style:'display:flex;gap:6px;margin-top:4px'},[
        el('button',{className:'kz-ret-btn kz-ret-btn-success',style:'width:auto;padding:8px 16px;font-size:12px',onclick:confirmAddress},'Confirmar endereço'),
        el('button',{className:'kz-ret-btn kz-ret-btn-secondary',style:'width:auto;padding:8px 16px;font-size:12px',onclick:function(){state.showAddress=false;render()}},'Cancelar'),
      ]);
      af.appendChild(abtn);
      chatBox.appendChild(af);
    }

    // Input row
    if(canUseInput){
      var previewTray=el('div',{className:'kz-ret-img-preview'+(state.images.length>0?' is-active':''),id:'kz-img-preview'});
      chatBox.appendChild(previewTray);
      var fileIn=el('input',{type:'file',accept:'image/jpeg,image/png,image/webp,image/heic,image/heif',multiple:'true',style:'display:none',id:'kz-file'});
      fileIn.disabled=state.sending;
      fileIn.onchange=function(e){
        if(state.sending){e.target.value='';return}
        var chatInp=$('kz-chat-in');
        if(chatInp)state._draftText=chatInp.value;
        var files=Array.prototype.slice.call(e.target.files||[]);
        e.target.value='';
        queueAttachmentIngestion(files);
      };
      if(showCatalogReopen){
        var reopenBar=el('div',{className:'kz-ret-catalog-reopen-bar'});
        var reopenBtn=el('button',{className:'kz-ret-catalog-reopen',id:'kz-catalog-reopen',type:'button',onclick:function(){
          if(state.sending)return;
          openOfferedCatalog();
          render();
        }},[
          el('span',{className:'kz-ret-catalog-reopen-icon','aria-hidden':'true'},'▦'),
          el('span',{},'Abrir catálogo')
        ]);
        reopenBtn.disabled=state.sending;
        reopenBtn.setAttribute('aria-label','Abrir catálogo de produtos para troca');
        reopenBtn.setAttribute('aria-haspopup','dialog');
        reopenBtn.setAttribute('aria-controls','kz-catalog-dialog');
        reopenBar.appendChild(reopenBtn);
        chatBox.appendChild(reopenBar);
      }
      var attachBtn=el('button',{className:'kz-ret-attach-btn',onclick:function(){if(!state.sending)$('kz-file').click()}},'📎');
      attachBtn.disabled=state.sending;
      var chatInput=el('textarea',{className:'kz-ret-chat-input',id:'kz-chat-in',placeholder:'Descreva o problema...',rows:'1',oninput:function(e){state._draftText=e.target.value;saveReturnSession()}});
      chatInput.disabled=state.sending;
      var sendBtn=el('button',{className:'kz-ret-send-btn',id:'kz-send',onclick:sendMsg},'➤');
      sendBtn.disabled=state.sending;
      var inputRow=el('div',{className:'kz-ret-input-row'},[
        fileIn,
        attachBtn,
        chatInput,
        sendBtn,
      ]);
      chatBox.appendChild(inputRow);
      updateImagePreviewTray(previewTray);
    }

    wrap.appendChild(chatBox);

    // Catalog overlay (rendered outside chat flow)
    if(state.showCatalog) setTimeout(renderCatalog,10);

    // Scroll to bottom + focus
    setTimeout(function(){
      scrollChatToBottom(false);
      var inp=$('kz-chat-in');
      if(inp&&state._draftText){inp.value=state._draftText;state._draftText=null}
      if(inp&&!state.sending&&!state.showCatalog)focusWithoutPageScroll(inp);
    },50);

    // Enter key + paste image
    setTimeout(function(){
      var inp=$('kz-chat-in');
      if(!inp) return;
      inp.onkeydown=function(e){if(e.key==='Enter'&&!e.shiftKey){e.preventDefault();sendMsg()}};
      // Paste image from clipboard
      inp.onpaste=function(e){
        if(state.sending)return;
        var items=e.clipboardData&&e.clipboardData.items;
        if(!items)return;
        var files=[];
        for(var i=0;i<items.length;i++){
          if(typeof items[i].getAsFile!=='function')continue;
          var f=items[i].getAsFile();
          if(f)files.push(f);
        }
        if(files.length){state._draftText=inp.value;e.preventDefault();queueAttachmentIngestion(files)}
      };
    },60);
  }

  function queueAttachmentIngestion(files){
    var incoming=Array.prototype.slice.call(files||[]);
    var flow=attachmentFlow;
    if(incoming.length===0)return flow.queue;
    flow.pending++;
    flow.queue=flow.queue.then(function(){
      if(!isCurrentAttachmentFlow(flow))return;
      if(!attachmentHelper||typeof attachmentHelper.ingestFiles!=='function'){
        throw new Error('Attachment helper unavailable');
      }
      return attachmentHelper.ingestFiles(state.images,incoming).then(function(result){
        if(!isCurrentAttachmentFlow(flow))return;
        state.images=result.attachments;
        if(result.errors.length){
          flow.errorVersion++;
          state.error=result.errors.map(function(item){return item.message}).join(' ');
          render();
        }else{
          state.error='';
          updateImagePreviewTray();
        }
      });
    }).catch(function(){
      if(!isCurrentAttachmentFlow(flow))return;
      flow.errorVersion++;
      state.error='Não foi possível validar as fotos. Tente novamente.';
      render();
    }).then(function(){
      flow.pending--;
    });
    return flow.queue;
  }

  function queueAttachmentRemoval(attachment){
    var flow=attachmentFlow;
    flow.pending++;
    flow.queue=flow.queue.then(function(){
      if(!isCurrentAttachmentFlow(flow))return;
      var index=state.images.indexOf(attachment);
      if(index!==-1)state.images.splice(index,1);
      updateImagePreviewTray();
    }).catch(function(){
      if(!isCurrentAttachmentFlow(flow))return;
      flow.errorVersion++;
      state.error='Não foi possível remover a foto. Tente novamente.';
      render();
    }).then(function(){
      flow.pending--;
    });
    return flow.queue;
  }

  function chatDistanceFromBottom(msgs){
    return msgs?msgs.scrollHeight-msgs.scrollTop-msgs.clientHeight:0;
  }

  function updateChatScrollButton(){
    var msgs=$('kz-msgs');
    var btn=$('kz-scroll-bottom');
    if(!msgs||!btn)return;
    positionChatScrollButton();
    btn.classList.toggle('is-visible',chatDistanceFromBottom(msgs)>90);
  }

  function getScrollButtonBottomOffset(chat){
    if(!chat)return 12;
    if(chat.classList.contains('kz-ret-chat--has-address'))return 172;
    if(chat.classList.contains('kz-ret-chat--has-catalog')&&chat.classList.contains('kz-ret-chat--has-preview'))return 200;
    if(chat.classList.contains('kz-ret-chat--has-catalog'))return 132;
    if(chat.classList.contains('kz-ret-chat--has-preview'))return 144;
    if(chat.classList.contains('kz-ret-chat--has-input'))return 76;
    return 12;
  }

  function positionChatScrollButton(){
    var btn=$('kz-scroll-bottom');
    var chat=document.querySelector('.kz-ret-chat');
    if(!btn||!chat)return;
    var rect=chat.getBoundingClientRect();
    btn.style.left=(rect.left+(rect.width/2))+'px';
    btn.style.bottom=Math.max(8,window.innerHeight-rect.bottom+getScrollButtonBottomOffset(chat))+'px';
  }

  function scrollChatToBottom(smooth){
    var msgs=$('kz-msgs');
    if(!msgs)return;
    try{
      msgs.scrollTo({top:msgs.scrollHeight,behavior:smooth?'smooth':'auto'});
    }catch(e){
      msgs.scrollTop=msgs.scrollHeight;
    }
    setTimeout(updateChatScrollButton,smooth?240:0);
  }

  function keepChatPinnedIfNearBottom(msgs){
    if(!msgs)return;
    if(chatDistanceFromBottom(msgs)<180)msgs.scrollTop=msgs.scrollHeight;
    updateChatScrollButton();
  }

  function updateImagePreviewTray(tray){
    var prev=tray||$('kz-img-preview');
    if(!prev)return;
    while(prev.firstChild)prev.removeChild(prev.firstChild);
    if(state.images.length>0)prev.classList.add('is-active');
    else prev.classList.remove('is-active');
    var chat=prev.closest?prev.closest('.kz-ret-chat'):null;
    if(chat)chat.classList.toggle('kz-ret-chat--has-preview',state.images.length>0);
    updateChatScrollButton();
    state.images.forEach(function(attachment,i){
      var file=attachment.file;
      var wrap2=el('div',{style:'position:relative;display:inline-block;flex:0 0 auto'});
      if(attachment.type==='image/heic'){
        wrap2.appendChild(el('div',{className:'kz-ret-img-thumb',style:'display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;color:#475569;background:#f8fafc'},'HEIC'));
      }else{
        var img=el('img',{className:'kz-ret-img-thumb is-previewable',alt:'Anexo selecionado'});
        var reader=new FileReader();
        reader.onload=function(e){img.src=e.target.result};
        reader.readAsDataURL(file);
        img.onclick=function(){if(img.src)openMediaPreview(img.src)};
        img.onkeydown=function(e){if((e.key==='Enter'||e.key===' ')&&img.src){e.preventDefault();openMediaPreview(img.src)}};
        img.setAttribute('tabindex','0');
        img.setAttribute('role','button');
        img.setAttribute('aria-label','Abrir imagem anexada');
        wrap2.appendChild(img);
      }
      var rm=el('button',{className:'kz-ret-img-rm',type:'button',onclick:function(){
        if(state.sending)return;
        var ci=$('kz-chat-in');if(ci)state._draftText=ci.value;
        queueAttachmentRemoval(attachment);
      }});
      rm.disabled=state.sending;
      rm.setAttribute('aria-label','Remover anexo');
      rm.textContent='x';
      wrap2.appendChild(rm);
      prev.appendChild(wrap2);
    });
  }

  function openMediaPreview(src){
    if(!src)return;
    var existing=document.querySelector('.kz-ret-media-overlay');
    if(existing)existing.remove();
    var overlay=el('div',{className:'kz-ret-media-overlay',role:'dialog','aria-modal':'true',onclick:function(e){if(e.target===overlay)close()}});
    var dialog=el('div',{className:'kz-ret-media-dialog'});
    var closeBtn=el('button',{className:'kz-ret-media-close',type:'button',onclick:function(e){e.stopPropagation();close()}},'×');
    closeBtn.setAttribute('aria-label','Fechar preview');
    var media;
    media=el('img',{src:src,alt:'Preview do anexo'});
    dialog.appendChild(media);
    dialog.appendChild(closeBtn);
    overlay.appendChild(dialog);
    document.body.appendChild(overlay);
    closeBtn.focus();

    function onKey(e){if(e.key==='Escape')close()}
    function close(){
      document.removeEventListener('keydown',onKey);
      if(overlay.parentNode)overlay.parentNode.removeChild(overlay);
    }
    document.addEventListener('keydown',onKey);
  }

  var catalogReturnFocus=null;
  var catalogKeyHandler=null;

  function removeCatalogOverlay(){
    var existing=document.querySelector('.kz-ret-catalog-overlay');
    if(existing&&existing.parentNode)existing.parentNode.removeChild(existing);
    if(catalogKeyHandler)document.removeEventListener('keydown',catalogKeyHandler);
    catalogKeyHandler=null;
    document.documentElement.classList.remove('kz-ret-catalog-open');
    document.body.classList.remove('kz-ret-catalog-open');
    app.removeAttribute('aria-hidden');
  }

  function closeCatalog(){
    if(state.catalogTimer)clearTimeout(state.catalogTimer);
    state.catalogTimer=null;
    state.catalogRequestId++;
    state.catalogSearching=false;
    state.showCatalog=false;
    removeCatalogOverlay();
    render();
    setTimeout(function(){
      var target=$('kz-catalog-reopen')||$('kz-chat-in');
      if(target)focusWithoutPageScroll(target);
      catalogReturnFocus=null;
    },60);
  }

  function openOfferedCatalog(searchSuggestion){
    if(state.step!=='chat'||state.returnCreated||state.returnCompleted||state.showAddress){
      state.catalogReopenAvailable=false;
      state.showCatalog=false;
      return false;
    }
    if(state.sending)return false;
    if(state.selectedLineItemIds.length!==1){
      state.showCatalog=false;
      clearSelectedExchange();
      if(state.selectedLineItemIds.length>1)addMultiExchangeNotice();
      else state.error='Não foi possível validar o produto do pedido. Atualize a página e tente novamente.';
      return false;
    }
    if(state.catalogTimer)clearTimeout(state.catalogTimer);
    state.catalogTimer=null;
    state.catalogRequestId++;
    state.catalogReopenAvailable=true;
    state.showCatalog=true;
    state.catalogResults=[];
    state.catalogExpanded=null;
    state.catalogError='';
    state.error='';
    var requestedSearch=typeof searchSuggestion==='string'?searchSuggestion:state.catalogSearch;
    requestedSearch=cleanText(String(requestedSearch||''),100).trim();
    state.catalogSearch=requestedSearch;
    loadCatalogProducts(requestedSearch.length>=2?requestedSearch:'KZ');
    return true;
  }

  function loadCatalogProducts(search,container){
    var query=String(search||'').trim();
    if(query.length<2||!state.showCatalog||!state.auth||!state.auth.token||!state.auth.payload)return;
    var requestId=++state.catalogRequestId;
    state.catalogSearching=true;
    state.catalogError='';
    if(container)renderCatalogList(container);
    var url=API+'/api/returns/public/catalog?token='+encodeURIComponent(state.auth.token)+'&payload='+encodeURIComponent(state.auth.payload)+'&q='+encodeURIComponent(query);
    fetch(url).then(function(response){
      return response.json().catch(function(){return{}}).then(function(data){return{ok:response.ok,data:data}});
    }).then(function(result){
      if(requestId!==state.catalogRequestId||!state.showCatalog)return;
      state.catalogSearching=false;
      if(!result.ok){
        if(handleAuthSessionError(result.data&&result.data.error))return;
        state.catalogResults=[];
        state.catalogError=result.data.error||'Não foi possível carregar os produtos.';
      }else{
        state.catalogResults=Array.isArray(result.data.products)?result.data.products:[];
        state.catalogError='';
      }
      var liveList=$('kz-catalog-list');
      if(liveList)renderCatalogList(liveList);
    }).catch(function(){
      if(requestId!==state.catalogRequestId||!state.showCatalog)return;
      state.catalogSearching=false;
      state.catalogResults=[];
      state.catalogError='Não foi possível carregar os produtos. Verifique sua conexão e tente novamente.';
      var liveList=$('kz-catalog-list');
      if(liveList)renderCatalogList(liveList);
    });
  }

  function renderCatalog(){
    removeCatalogOverlay();
    if(!state.showCatalog)return;
    if(!catalogReturnFocus||!document.documentElement.contains(catalogReturnFocus))catalogReturnFocus=document.activeElement||$('kz-chat-in');
    document.documentElement.classList.add('kz-ret-catalog-open');
    document.body.classList.add('kz-ret-catalog-open');

    var overlay=el('div',{className:'kz-ret-catalog-overlay',onclick:function(e){if(e.target===overlay)closeCatalog()}});
    var modal=el('div',{className:'kz-ret-catalog',id:'kz-catalog-dialog',role:'dialog','aria-modal':'true','aria-labelledby':'kz-catalog-title'});
    var header=el('div',{className:'kz-ret-catalog-header'});
    var heading=el('div',{className:'kz-ret-catalog-heading'});
    var headingCopy=el('div');
    headingCopy.appendChild(el('h2',{className:'kz-ret-catalog-title',id:'kz-catalog-title'},'Escolha o produto de troca'));
    headingCopy.appendChild(el('p',{className:'kz-ret-catalog-subtitle'},'Selecione o produto e depois o modelo desejado.'));
    var closeBtn=el('button',{className:'kz-ret-catalog-close',type:'button',onclick:closeCatalog},'×');
    closeBtn.setAttribute('aria-label','Fechar catálogo');
    heading.appendChild(headingCopy);heading.appendChild(closeBtn);
    header.appendChild(heading);

    var searchWrap=el('div',{className:'kz-ret-catalog-search-wrap'});
    searchWrap.appendChild(el('span',{className:'kz-ret-catalog-search-icon','aria-hidden':'true'},'⌕'));
    var searchInp=el('input',{className:'kz-ret-catalog-search',placeholder:'Buscar por nome do produto',id:'kz-catalog-search',type:'search',autocomplete:'off','aria-label':'Buscar produto para troca'});
    searchInp.value=state.catalogSearch;
    searchInp.oninput=function(e){
      var val=e.target.value;
      state.catalogSearch=val;
      state.catalogExpanded=null;
      state.catalogError='';
      if(state.catalogTimer)clearTimeout(state.catalogTimer);
      state.catalogRequestId++;
      if(val.trim().length<2){
        state.catalogSearching=false;
        state.catalogResults=[];
        renderCatalogList(list);
        return;
      }
      state.catalogTimer=setTimeout(function(){loadCatalogProducts(val,list)},300);
    };
    searchWrap.appendChild(searchInp);
    header.appendChild(searchWrap);
    modal.appendChild(header);

    var list=el('div',{className:'kz-ret-catalog-list',id:'kz-catalog-list',role:'region','aria-live':'polite','aria-label':'Produtos encontrados'});
    renderCatalogList(list);
    modal.appendChild(list);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
    app.setAttribute('aria-hidden','true');

    catalogKeyHandler=function(e){
      if(e.key==='Escape'){e.preventDefault();closeCatalog();return}
      if(e.key!=='Tab')return;
      var focusable=modal.querySelectorAll('button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])');
      if(!focusable.length)return;
      var first=focusable[0];
      var last=focusable[focusable.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
    };
    document.addEventListener('keydown',catalogKeyHandler);
    focusWithoutPageScroll(isMobile()?closeBtn:searchInp);
  }

  function appendCatalogImage(parent,preferred,fallback,className,placeholderClass,alt){
    var primary=safeImageUrl(preferred);
    var backup=safeImageUrl(fallback);
    if(!primary)primary=backup;
    if(!primary){parent.appendChild(el('span',{className:placeholderClass,'aria-hidden':'true'},'▧'));return}
    var img=el('img',{className:className,src:primary,alt:alt||''});
    img.loading='lazy';
    img.onerror=function(){
      if(backup&&img.src!==backup){img.src=backup;backup='';return}
      if(img.parentNode)img.parentNode.replaceChild(el('span',{className:placeholderClass,'aria-hidden':'true'},'▧'),img);
    };
    parent.appendChild(img);
  }

  function renderCatalogList(container){
    if(!container)return;
    while(container.firstChild)container.removeChild(container.firstChild);

    if(state.catalogSearching){
      var loading=el('div',{className:'kz-ret-catalog-status',role:'status'});
      loading.appendChild(el('span',{className:'kz-ret-catalog-status-title'},'Buscando produtos…'));
      loading.appendChild(document.createTextNode('Isso deve levar só alguns segundos.'));
      container.appendChild(loading);return;
    }
    if(state.catalogError){
      var error=el('div',{className:'kz-ret-catalog-status',role:'alert'});
      error.appendChild(el('span',{className:'kz-ret-catalog-status-title'},'Não foi possível carregar o catálogo'));
      error.appendChild(document.createTextNode(state.catalogError));
      container.appendChild(error);return;
    }
    if(String(state.catalogSearch||'').trim().length<2&&state.catalogResults.length===0){
      var hint=el('div',{className:'kz-ret-catalog-status'});
      hint.appendChild(el('span',{className:'kz-ret-catalog-status-title'},'Encontre o produto ideal'));
      hint.appendChild(document.createTextNode('Digite pelo menos 2 caracteres para buscar.'));
      container.appendChild(hint);return;
    }
    if(state.catalogResults.length===0){
      var empty=el('div',{className:'kz-ret-catalog-status'});
      empty.appendChild(el('span',{className:'kz-ret-catalog-status-title'},'Nenhum produto encontrado'));
      empty.appendChild(document.createTextNode('Tente buscar usando outro termo.'));
      container.appendChild(empty);return;
    }

    state.catalogResults.forEach(function(p,index){
      var variants=Array.isArray(p.variants)?p.variants:[];
      if(!variants.length)return;
      var singleVariant=variants.length===1;
      var isExpanded=state.catalogExpanded===p.handle;
      var variantsId='kz-catalog-variants-'+index;
      var productButtonId='kz-catalog-product-'+index;
      var card=el('div',{className:'kz-ret-catalog-card'+(isExpanded?' is-expanded':'')});

      var headerBtn=el('button',{className:'kz-ret-catalog-item',id:productButtonId,type:'button',onclick:function(){
        if(singleVariant){selectCatalogProduct(p,variants[0]);return}
        state.catalogExpanded=isExpanded?null:p.handle;
        renderCatalogList(container);
        setTimeout(function(){
          var expanded=document.getElementById(variantsId);
          if(expanded&&state.catalogExpanded===p.handle){
            expanded.scrollIntoView({block:'nearest'});
            var firstVariant=expanded.querySelector('button');
            if(firstVariant)focusWithoutPageScroll(firstVariant);
          }else{
            var collapsedButton=document.getElementById(productButtonId);
            if(collapsedButton)focusWithoutPageScroll(collapsedButton);
          }
        },0);
      }});
      if(!singleVariant){headerBtn.setAttribute('aria-expanded',isExpanded?'true':'false');headerBtn.setAttribute('aria-controls',variantsId)}
      appendCatalogImage(headerBtn,singleVariant&&variants[0].image, p.image,'kz-ret-catalog-img','kz-ret-catalog-img-placeholder',p.title||'Produto');
      var info=el('span',{className:'kz-ret-catalog-product-info'});
      info.appendChild(el('span',{className:'kz-ret-catalog-product-title'},p.title||'Produto'));
      var meta='';
      if(singleVariant){
        var onlyTitle=String(variants[0].title||'').trim();
        meta=(onlyTitle&&onlyTitle!=='Default Title'?onlyTitle+' · ':'')+formatPriceBRL(variants[0].price||p.price);
      }else{
        meta=variants.length+' modelos · a partir de '+formatPriceBRL(p.price||variants[0].price);
      }
      info.appendChild(el('span',{className:'kz-ret-catalog-product-meta'},meta));
      headerBtn.appendChild(info);
      if(singleVariant){headerBtn.appendChild(el('span',{className:'kz-ret-catalog-select-label'},'Selecionar'))}
      else{headerBtn.appendChild(el('span',{className:'kz-ret-catalog-arrow'+(isExpanded?' is-expanded':''),'aria-hidden':'true'},'▾'))}
      card.appendChild(headerBtn);

      if(isExpanded&&!singleVariant){
        var variantsDiv=el('div',{className:'kz-ret-catalog-variants',id:variantsId});
        variants.forEach(function(v){
          var row=el('button',{className:'kz-ret-catalog-variant',type:'button',onclick:function(){selectCatalogProduct(p,v)}});
          appendCatalogImage(row,v.image,p.image,'kz-ret-catalog-variant-img','kz-ret-catalog-variant-placeholder',(p.title||'Produto')+' '+(v.title||''));
          row.appendChild(el('span',{className:'kz-ret-catalog-variant-name'},v.title||'Modelo padrão'));
          row.appendChild(el('span',{className:'kz-ret-catalog-variant-price'},formatPriceBRL(v.price)));
          variantsDiv.appendChild(row);
        });
        card.appendChild(variantsDiv);
      }
      container.appendChild(card);
    });
  }

  function selectCatalogProduct(product,variant){
    var variantLabel=variant.title?(product.title+' — '+variant.title):product.title;
    var msg='Gostaria de trocar por: '+variantLabel+' ('+formatPriceBRL(variant.price)+')';
    var localSelection=cleanCatalogSelection({
      handle:product.handle,
      variant_id:variant.id,
      variant_title:variant.title,
      product_name:product.title,
      price:variant.price,
      image:safeImageUrl(variant.image)||safeImageUrl(product.image)
    });
    if(!localSelection){state.error='Não foi possível identificar este modelo. Escolha outro produto e tente novamente.';closeCatalog();return}
    if(state.selectedLineItemIds.length!==1){
      clearSelectedExchange();
      if(state.selectedLineItemIds.length>1)addMultiExchangeNotice();
      else state.error='Não foi possível validar o produto do pedido. Atualize a página e tente novamente.';
      closeCatalog();return;
    }
    state.showCatalog=false;
    state.catalogRequestId++;
    if(state.catalogTimer)clearTimeout(state.catalogTimer);
    state.catalogTimer=null;
    removeCatalogOverlay();
    var pendingMessage={role:'user',content:'Confirmando '+variantLabel+'…'};
    state.history.push(pendingMessage);
    state.sending=true;state.chatRequestInFlight=true;state.error='';render();
    var payload={
      token:state.auth.token,payload:state.auth.payload,
      turn_id:createTurnId(),
      message:msg,
      selected_line_item_ids:state.selectedLineItemIds.slice(),
      catalog_selection:{handle:String(product.handle),variant_id:String(variant.id)}
    };
    fetch(API+'/api/returns/public/chat',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload)})
    .then(function(r){return r.json().then(function(d){return{ok:r.ok,data:d}})})
    .then(function(res){
      state.chatRequestInFlight=false;
      state.sending=false;
      if(!res.ok){
        if(handleAuthSessionError(res.data&&res.data.error))return;
        pendingMessage.content='Não foi possível confirmar '+variantLabel+'.';
        state.error=res.data.error||'Não foi possível confirmar o produto escolhido.';
        render();return;
      }
      if(res.data.accumulated_image_urls)state.accumulatedImageUrls=res.data.accumulated_image_urls;
      if(res.data.return_context)state.returnContext=res.data.return_context;
      syncExchangeResponse(res.data,pendingMessage,localSelection);
      addBotMsg(res.data.reply);
      if(res.data.action){
        var act=res.data.action;
        if(act.type==='return_created'){
          var sysMsg='Solicitação registrada! Acompanhe o andamento aqui nesta página.';
          if(act.auto_action==='AUTO_RESHIP_NO_RETURN')sysMsg='Troca registrada! Você NÃO precisa devolver o produto com defeito. Um novo será enviado para você.';
          else if(act.auto_action==='AUTO_LABEL_AND_RESHIP'&&act.tracking_code)sysMsg='Troca registrada! Código de postagem: '+act.tracking_code+'. Aguarde de 1 a 2 horas antes de ir à agência — o sistema dos Correios pode levar esse tempo para liberar seu código. Um novo produto já foi adicionado ao seu pedido.';
          else if(act.auto_action==='AUTO_LABEL'&&act.tracking_code)sysMsg='Solicitação aprovada! Código de postagem: '+act.tracking_code+'. Aguarde de 1 a 2 horas antes de ir à agência — o sistema dos Correios pode levar esse tempo para liberar seu código. Depois é só levar o produto a qualquer agência e informar o código no guichê.';
          state.history.push({role:'system',content:sysMsg});
          state.returnCreated=true;
        } else if(act.type==='error'){
          state.error=act.message||'Erro ao processar';
        } else if(act.type==='reject'){
          state.history.push({role:'system',content:'Solicitação encerrada.'});
          state.returnCreated=true;
        }
      }
      render();
    }).catch(function(){
      state.chatRequestInFlight=false;
      state.sending=false;
      pendingMessage.content='Não foi possível confirmar '+variantLabel+'.';
      state.error='Erro de conexão. Tente selecionar o produto novamente.';
      render();
    });
  }

  function makeInput(id,label,value){
    var inp=el('input',{id:id,placeholder:label});
    inp.value=value;
    return inp;
  }

  function sendMsg(){
    var inp=$('kz-chat-in');
    var draftText=inp?inp.value:'';
    var text=draftText.trim();
    var flow=attachmentFlow;
    if(state.sending)return;
    if(flow.pending>0){
      var errorVersion=flow.errorVersion;
      state._draftText=draftText;
      flow.queue.then(function(){
        if(!isCurrentAttachmentFlow(flow)||state.step!=='chat'||flow.errorVersion!==errorVersion)return;
        sendMsg();
      });
      return;
    }
    if(!text&&state.images.length===0)return;
    if(state.selectedLineItemIds.length===0){
      state.error='Não foi possível validar o produto do pedido. Atualize a página e tente novamente.';
      render();return;
    }

    var catalogSelection=state.catalogSelectedProduct?{
      handle:String(state.catalogSelectedProduct.handle),
      variant_id:String(state.catalogSelectedProduct.variant_id)
    }:null;
    var sendSnapshot={
      flow:flow,
      authToken:state.auth&&state.auth.token,
      authPayload:state.auth&&state.auth.payload,
      orderNumber:String(state.selectedOrder||''),
      selectedLineItemIds:state.selectedLineItemIds.slice(),
      catalogSelection:catalogSelection,
      pendingImages:state.images.slice(),
      previousImageCount:state.accumulatedImageUrls.length,
      draftText:draftText,
      text:text
    };
    if(typeof Object.freeze==='function'){
      Object.freeze(sendSnapshot.selectedLineItemIds);
      Object.freeze(sendSnapshot.pendingImages);
      if(sendSnapshot.catalogSelection)Object.freeze(sendSnapshot.catalogSelection);
      Object.freeze(sendSnapshot);
    }
    function restoreUnsentDraft(){
      state._draftText=sendSnapshot.draftText;state.images=sendSnapshot.pendingImages.slice();
      var currentInput=$('kz-chat-in');
      if(currentInput)currentInput.value=sendSnapshot.draftText;
    }
    state._draftText=draftText;
    state.sending=true;
    state.activityLabel=sendSnapshot.pendingImages.length?'Preparando fotos…':'Digitando...';
    state.error='';render();

    function preparationFailed(error){
      if(!isCurrentAttachmentFlow(sendSnapshot.flow))return;
      state.sending=false;
      state.chatRequestInFlight=false;
      state.activityLabel='';
      state.error=error&&error.message?error.message:'Não foi possível preparar as fotos. Tente novamente ou envie em JPG, PNG ou WebP.';
      restoreUnsentDraft();
      render();
    }

    var preparation;
    try{
      preparation=sendSnapshot.pendingImages.length&&attachmentHelper&&typeof attachmentHelper.prepareImages==='function'
        ?attachmentHelper.prepareImages(sendSnapshot.pendingImages,attachmentAdapters)
        :Promise.resolve(sendSnapshot.pendingImages.length?{ok:false,error:{message:'Não foi possível preparar as fotos. Tente novamente.'}}:{ok:true,images:[]});
    }catch(error){preparationFailed(error);return}

    Promise.resolve(preparation).then(function(prepared){
      if(!isCurrentAttachmentFlow(sendSnapshot.flow))return;
      if(!prepared||!prepared.ok){preparationFailed(prepared&&prepared.error);return}
      var preparedImages=prepared.images;
      if(preparedImages.some(function(image){return image.data.length>=MAX_CHAT_IMAGE_DATA_LENGTH})){
        preparationFailed({message:CHAT_IMAGE_TOO_LARGE_MESSAGE});return;
      }
      var payload={
        token:sendSnapshot.authToken,
        payload:sendSnapshot.authPayload,
        turn_id:createTurnId(),
        message:sendSnapshot.text,
        images:preparedImages.length?preparedImages:undefined,
        selected_line_item_ids:sendSnapshot.selectedLineItemIds.slice(),
        catalog_selection:sendSnapshot.catalogSelection||undefined
      };
      var requestBody=JSON.stringify(payload);
      if(requestBody.length>MAX_CHAT_BODY_LENGTH){
        preparationFailed({message:CHAT_BODY_TOO_LARGE_MESSAGE});return;
      }
      var bubbleImages=preparedImages.map(function(image){return'data:image/jpeg;base64,'+image.data});
      var pendingMessage={role:'user',content:sendSnapshot.text||(preparedImages.length?'📷 Foto enviada':''),images:bubbleImages};
      function sendFailed(message){
        state.chatRequestInFlight=false;state.sending=false;state.activityLabel='';
        var pendingIndex=state.history.indexOf(pendingMessage);
        if(pendingIndex!==-1)state.history.splice(pendingIndex,1);
        restoreUnsentDraft();
        state.error=message;render();
      }
      state.history.push(pendingMessage);
      state._draftText='';
      state.images=[];
      state.chatRequestInFlight=true;
      state.activityLabel='Digitando...';
      render();

      fetch(API+'/api/returns/public/chat',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:requestBody
      }).then(function(r){return r.json().then(function(d){return{ok:r.ok,data:d}})})
      .then(function(res){
        if(!isCurrentAttachmentFlow(sendSnapshot.flow))return;
        state.chatRequestInFlight=false;
        state.sending=false;
        state.activityLabel='';
        if(!res.ok){if(handleAuthSessionError(res.data&&res.data.error))return;sendFailed(res.data.error||'Erro');return}

        // Save accumulated image URLs and return context from server
        if(res.data.accumulated_image_urls){
          state.accumulatedImageUrls=res.data.accumulated_image_urls;
          var newImageUrls=state.accumulatedImageUrls.slice(sendSnapshot.previousImageCount,sendSnapshot.previousImageCount+preparedImages.length);
          if(newImageUrls.length===preparedImages.length)pendingMessage.images=newImageUrls;
        }
        if(res.data.return_context) state.returnContext=res.data.return_context;
        syncExchangeResponse(res.data);

        addBotMsg(res.data.reply);

      // Handle actions
        if(res.data.action){
        var act=res.data.action;
        if(act.type==='return_created'){
          // Contextual system message based on action type
          var sysMsg='';
          var canonicalPreference=act._debug&&act._debug.preference;
          if(act.auto_action==='AUTO_RESHIP_NO_RETURN'){
            sysMsg='Troca registrada! Você NÃO precisa devolver o produto com defeito. Um novo será enviado para você. Acompanhe o status aqui nesta página.';
          } else if(act.auto_action==='AUTO_LABEL_AND_RESHIP'&&act.tracking_code){
            sysMsg='Troca registrada! Código de postagem: '+act.tracking_code+'. Aguarde de 1 a 2 horas antes de ir à agência — o sistema dos Correios pode levar esse tempo para liberar seu código. Um novo produto já foi adicionado ao seu pedido. Acompanhe tudo aqui nesta página.';
          } else if(act.auto_action==='AUTO_LABEL'&&act.tracking_code){
            sysMsg='Solicitação aprovada! Código de postagem: '+act.tracking_code+'. Aguarde de 1 a 2 horas antes de ir à agência — o sistema dos Correios pode levar esse tempo para liberar seu código. Depois leve o produto a qualquer agência e informe este código no guichê. Acompanhe o andamento aqui nesta página.';
          } else if(act.no_return&&canonicalPreference==='refund'){
            sysMsg='Solicitação registrada! Você NÃO precisa devolver o produto. Nosso time vai processar seu reembolso em breve. Acompanhe o andamento aqui nesta página.';
          } else if(act.no_return&&canonicalPreference==='exchange'){
            sysMsg='Troca registrada! Você NÃO precisa devolver o produto. Nossa equipe vai validar a reposição e avisar você antes do envio. Acompanhe o andamento aqui nesta página.';
          } else {
            sysMsg='Solicitação registrada! Acompanhe o andamento aqui nesta página — o status será atualizado conforme o processo avança.';
          }
          state.history.push({role:'system',content:sysMsg});
          state.returnCreated=true;
        } else if(act.type==='confirm_delivery_address'){
          // Troca: return already created, now confirm where to send the NEW product
          state.addressData=act.address||{};
          state.addressMode='delivery'; // delivery address for new product
          state.showAddress=true;
          state.history.push({role:'system',content:'Devolução registrada! Agora confirme o endereço para receber o produto de troca.'});
        } else if(act.type==='need_address'){
          // Legacy action: never create from client-provided return data.
          state.showAddress=false;
          state.history.push({role:'notification',content:'Não foi possível concluir esta solicitação com segurança. Fale com nossa equipe pelo WhatsApp: https://wa.me/5551997465452'});
          state.returnCompleted=true;
        } else if(act.type==='error'){
          state.error=act.message||'Erro ao processar';
        } else if(act.type==='open_catalog'){
          openOfferedCatalog(act.search_suggestion||'');
        } else if(act.type==='reject'){
          state.history.push({role:'system',content:'Solicitação encerrada.'});
          state.returnCreated=true;
        }
        }
        render();
      }).catch(function(){
        if(!isCurrentAttachmentFlow(sendSnapshot.flow))return;
        sendFailed('Erro de conexão. Tente enviar novamente.');
      });
    },function(error){preparationFailed({message:'Não foi possível preparar as fotos. Tente novamente ou envie em JPG, PNG ou WebP.'})});
  }

  function confirmAddress(){
    var addr=($('kz-a-addr')||{}).value||'';
    var city=($('kz-a-city')||{}).value||'';
    var st=($('kz-a-state')||{}).value||'';
    var zip=($('kz-a-zip')||{}).value||'';

    if(!addr.trim()||!city.trim()||!st.trim()||!zip.trim()){
      state.error='Preencha o endereço completo';render();return;
    }

    state.showAddress=false;
    state.error='';
    addUserMsg('Endereço de entrega: '+addr+', '+city+'/'+st+' CEP '+zip);

    if(state.addressMode==='delivery'){
      // Troca: return already created, just confirm delivery address for new product
      state.history.push({role:'system',content:'Endereço de entrega confirmado! Sua solicitação de troca está em andamento. Analisaremos em até 3 dias úteis.'});
      state.returnCreated=true;
      render();
      return;
    }

    state.history.push({role:'notification',content:'Não foi possível concluir esta solicitação com segurança. Fale com nossa equipe pelo WhatsApp: https://wa.me/5551997465452'});
    state.returnCompleted=true;
    render();
  }

  window.addEventListener('beforeunload',saveReturnSession);
  window.addEventListener('resize',updateChatScrollButton);
  render();
})();
